/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-plusplus */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  Form,
  Row,
  Col,
  Modal,
  Button,
  Spin,
  DatePicker,
  Input,
  Tabs,
  Grid,
  Typography,
  notification,
  message,
  Empty,
  Divider,
  Radio,
  Progress,
  Menu,
} from 'antd';
import { onError } from 'utils/handlers';
import {
  FilePdfOutlined,
  ArrowLeftOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  CheckCircleTwoTone,
  BankOutlined,
  EyeOutlined,
  CloseOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import {
  getNominasPlazas,
  getNominaPlaza,
  deleteNominaPlaza,
  postNominaPlaza,
  importarDeduccionIMSS,
} from 'api/nominas/calculosDeNominas';
import Dragger from 'components/Dragger';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import {
  getCalculoDeNomina,
  getNominasPlazasPercepciones,
  getNominasPlazasDeducciones,
  getNominasPlazasDescuentos,
  getProgresoCalculo,
  postDetenerCalculo,
  recalcularNomina,
  recalcularNominaEmpleados,
} from 'api/nominas/calculosDeNominaEncabezado';
import API from 'utils/api';
import Table from 'components/Table';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import CurrencyInput from 'components/CurrencyInput';
import {
  ESTATUS_AUTORIZADO, ESTATUS_CANCELADO, NOMINA_ORDINARIA, ESTADO_SUSPENDIDO,
} from 'utils/constants';
import FormSubmitControls from 'components/FormSubmitControls';
import { getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import makeMessager from 'utils/complexFormsMessages';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getTabuladoresNominales } from 'api/nominas/tabuladores/tabuladoresNominales';
import { getPuestos } from 'api/catalogos/puestos';
import {
  getEmpleadosWithoutFilter,
  getEmpleado,
} from 'api/estructuraOrganizacional/empleados';
import {
  getDatoOperacionalesDeEmpleados,
  getDatoOperacionalPorEmpleado,
} from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getDatosDePagoDeEmpleados } from 'api/estructuraOrganizacional/datosDePagoDeEmpleados';
import { getNominasOrigenesRecursos } from 'api/nominas/nominasOrigenesRecursos';
import currencyFormatter from 'utils/currencyFormatter';
import { checkToken } from 'api/utils';
import { getNominasPlazasOtrosPagos } from 'api/nominas/nominasPlazasOtrosPagos';
import { getOrigenesRecursosNominas } from 'api/catalogos/origenesRecursosNominas';
import { getBancos } from 'api/configuraciones/bancos';
import { getImssNominas } from 'api/nominas/NominaIMSS';
import { postObtenerReporte } from 'api/reporteador';
import { getDispersionBancariaNomina, descargarPagDispersionBancaria } from 'api/nominas/dispersionBancariaNomina';
import { hasActionPermission } from 'utils/permission';
import { getSujetoDeNominaLabels } from 'utils/sujetosDeNomina';
import { readPersistedTableQuery } from 'utils/tableFiltersStorage';
import AsistenteChatWidget from 'components/AsistenteIA/AsistenteChatWidget';
import ExportadorExcelPersonalizado from 'components/ExportadorExcelPersonalizado';
import TITULOS_COLUMNAS_NOMINA from 'utils/titulosExportacionNomina';
import * as XLSX from 'xlsx';
import NominasPercepciones from './NominasPercepciones';
import NominasDeducciones from './NominaDeducciones';
import NominasISR from './NominasISR';
import NominasISN from './NominasISN';
import NominasDescuentos from './NominasDescuentos';
import NominasPlazasOtrosPagos from './NominasPlazasOtrosPagos';
import NominasIPEJAL from './NominasIPEJAL';
import NominasIMSS from './NominasIMSS';

const { TabPane } = Tabs;
const { Text } = Typography;
const baseURI = 'nominas/nominas-plazas';
// Id fijo de la tabla de Detalle Nómina -- ver storageId en el <Table> de abajo. Con un
// storageId explícito la clave de sessionStorage no depende del arreglo de columnas (ver
// utils/tableFiltersStorage.js), así que sigue resolviendo aunque cambien las columnas.
const TABLE_STORAGE_ID = 'calculo-de-nominas-detalle';
// Búsqueda (p. ej. "Número de Empleado") que el usuario ya tecleó en la tabla, para que los
// refrescos de `data` que NO vienen del propio <Table> (terminar un cálculo, importar DED-02,
// agregar/eliminar una Plaza) no la pierdan y el usuario tenga que volver a capturarla --
// mismo patrón ya usado en CalculosDeNominaEncabezado.jsx/Plazas.jsx/CargaExternaDescuentos.jsx.
const busquedaGuardada = () => readPersistedTableQuery(window.location.pathname, {
  storageId: TABLE_STORAGE_ID,
});

// Si un empleado tiene mas de un registro del mismo concepto (p.ej. dos filas de "DED-01 -
// ISR SUELDOS": el ISR del Aguinaldo y el ISR del ajuste P199-BIS), cada ocurrencia adicional
// debe ir en su propia columna ("... (2)", "... (3)", etc.) en el Excel Completo -- de lo
// contrario todas comparten la misma llave de columna y cada una sobreescribe a la anterior.
const nombreColumnaConSufijo = (nombreBase, ocurrencia) => (
  ocurrencia > 1 ? `${nombreBase} (${ocurrencia})` : nombreBase
);

export const calculoDeNominaPermission = {
  permissionModel: 'nominaplaza',
  catalogsModels: [],
  tabsModels: [],
};

// Modal principal para seleccionar tipo de exportación
const ModalExportOptions = ({ visible, onCancel, onConfirm }) => {
  const [exportType, setExportType] = useState('completo');

  const handleConfirm = () => {
    onConfirm({ exportType });
  };

  return (
    <Modal
      title="Opciones de Exportación"
      open={visible}
      onCancel={onCancel}
      width={500}
      footer={[
        <Button key="cancel" onClick={onCancel} type="link">
          Cancelar
        </Button>,
        <Button key="confirm" onClick={handleConfirm} type="link">
          {exportType === 'personalizado' ? 'Continuar' : 'Exportar Excel'}
        </Button>,
      ]}
    >
      <Radio.Group
        onChange={(e) => setExportType(e.target.value)}
        value={exportType}
        style={{ marginBottom: 20 }}
      >
        <Radio value="completo">Excel Completo (Todos los campos)</Radio>
        <Radio value="personalizado">Excel Personalizado (Seleccionar columnas)</Radio>
        <Radio value="porArea">Exportar por Directorio Área</Radio>
        <Radio value="despensa" style={{ display: 'block' }}>Reporte de Despensa</Radio>
      </Radio.Group>
    </Modal>
  );
};

// Modal para seleccionar tipo de dispersión bancaria
const ModalDispersionOptions = ({
  visible, onCancel, onConfirm, sujetoSingular,
}) => {
  const [dispersionType, setDispersionType] = useState('pag');

  return (
    <Modal
      title="Opciones de Dispersión Bancaria"
      open={visible}
      onCancel={onCancel}
      width={450}
      footer={[
        <Button key="cancel" onClick={onCancel} type="link">
          Cancelar
        </Button>,
        <Button key="confirm" onClick={() => onConfirm(dispersionType)} type="link">
          Generar
        </Button>,
      ]}
    >
      <Radio.Group
        onChange={(e) => setDispersionType(e.target.value)}
        value={dispersionType}
        style={{ marginBottom: 20 }}
      >
        <Radio value="pag">Formato PAG (TXT)</Radio>
        <Radio value="excel">Formato Excel (XLSX)</Radio>
      </Radio.Group>
      {dispersionType === 'excel' && (
        <div style={{
          marginTop: 16, padding: 12, backgroundColor: '#f5f5f5', borderRadius: 4,
        }}
        >
          <Text type="secondary">
            {`El archivo Excel contendrá las columnas: Número de ${sujetoSingular}, Apellido Paterno,
            Apellido Materno, Nombre del ${sujetoSingular}, Nombre Completo del ${sujetoSingular}, Cuenta Bancaria e Importe.`}
          </Text>
        </div>
      )}
    </Modal>
  );
};

const CalculoDeNomina = ({
  permission,
  selected,
  encabezado,
  fetchEncabezado,
  calculando,
  onEncabezadoUpdate,
  onSetCalculando,
  onSetOrigenesRecursos,
  onCalculoTerminado,
  onCalculoDetenido,
  periodosNominasDetalles,
  tiposNominasEmpleados,
  periodicidades,
  tiposNominas,
  periodosFiscales,
}) => {
  const entidad = useSelector(({ auth }) => auth.entidad);
  const razonSocial = entidad?.razon_social || 'Entidad no especificada';

  const tipoNominaEmpleadoActual = tiposNominasEmpleados?.find((e) => e.id === encabezado?.tipo_de_nomina_empleado);
  const contentTypeModel = tipoNominaEmpleadoActual?.content_type_model;
  const sujetoLabels = getSujetoDeNominaLabels(contentTypeModel);

  const getNombreSujeto = (plaza) => {
    if (contentTypeModel === 'becario') return plaza?.numero_y_nombre_becario || '';
    if (contentTypeModel === 'honorarioasimilado') return plaza?.numero_y_nombre_honorario_asimilado || '';
    return plaza?.numero_y_nombre_empleado || '';
  };

  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [loadingDetener, setLoadingDetener] = useState(false);
  const [form] = Form.useForm();
  const [formPlaza] = Form.useForm();
  const [open, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [empleadosDatosOperacionales, setEmpleadosDatosOperacionales] = useState([]);
  const [nombreEmpleado, setNombreEmpleado] = useState('');
  const [puesto, setPuesto] = useState('');
  const [plaza, setPlaza] = useState('');
  const [area, setArea] = useState('');
  const [rfc, setRfc] = useState('');
  const [curp, setCurp] = useState('');
  const [nss, setNss] = useState('');
  const [sindicato, setSindicato] = useState('');
  const [currentTabKey, setCurrentTabKey] = useState('nomina');
  const [mutable, setMutable] = useState(true);
  const [nominaPlaza, setNominaPlaza] = useState();
  const [visibleEliminar, setVisibleEliminar] = useState(false);
  const [visibleAgregar, setVisibleAgregar] = useState(false);
  const [nombre, setNombre] = useState('');
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [tabularesNominales, setTabuladoresNominales] = useState([]);
  const [tabuladorNominal, setTabuladorNominal] = useState('');
  const [sueldoDiario, setSueldoDiario] = useState('');
  const [bancoPago, setBancoPago] = useState('');
  const [numeroCuenta, setNumeroCuenta] = useState('');
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [nominasPlazasPercepciones, setNominasPlazasPercepciones] = useState([]);
  const [nominasPlazasDeducciones, setNominasPlazasDeducciones] = useState([]);
  const [nominasPlazasDescuentos, setNominasPlazasDescuentos] = useState([]);
  const [nominasPlazasOtrosPagos, setNominasPlazasOtrosPagos] = useState([]);
  const [imssNominas, setImssNominas] = useState([]);
  const [fechaDeAltaEmpleado, setFechaDeAltaEmpleado] = useState('');
  const [origenDelRecurso, setOrigenDelRecurso] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfBase64, setPdfBase64] = useState('');
  const [loadingPdfModal, setLoadingPdfModal] = useState(false);
  const intervalRef = useRef(null);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showExportadorPersonalizado, setShowExportadorPersonalizado] = useState(false);
  const [showDispersionModal, setShowDispersionModal] = useState(false);
  const [visibleRecalcular, setVisibleRecalcular] = useState(false);
  const [visibleRecalcularEmpleados, setVisibleRecalcularEmpleados] = useState(false);
  const [progresoCalculo, setProgresoCalculo] = useState({ calculadas: 0, total: 0 });

  const [formCargaDeduccionIMSS] = Form.useForm();
  const [visibleModalImportarDeduccionIMSS, setVisibleModalImportarDeduccionIMSS] = useState(false);
  const [isPollingImportDeduccionIMSS, setIsPollingImportDeduccionIMSS] = useState(false);
  const [progresoImportDeduccionIMSS, setProgresoImportDeduccionIMSS] = useState({ en_curso: 0, total: 0 });
  const pollingImportDeduccionIMSSRef = useRef(null);
  const DESCRIPCION_PROCESO_IMPORTAR_DEDUCCION_IMSS = `Importar Deduccion IMSS Nomina ${selected}`;

  // Por ningún motivo un empleado Suspendido debe ser calculado en nómina (caso real:
  // nómina 00589, empleado 6794). Se excluye aquí también del picker de "Agregar plaza a
  // la nómina", que es otra vía además del cálculo masivo por la que se podía incluir
  // manualmente a alguien Suspendido (ver también el bloqueo equivalente en
  // CalculosDeNominaEncabezado.jsx para el cálculo normal).
  const esEmpleadoSuspendido = (empleadoId) => {
    if (!empleadoId) return false;
    const empleado = empleados.find((e) => e.id === empleadoId || e.pk === empleadoId);
    return empleado?.estado_del_empleado === ESTADO_SUSPENDIDO;
  };

  const filtrarPlazasPorSujeto = (plazasArr) => {
    if (contentTypeModel === 'becario') {
      return plazasArr.filter((ap) => ap.becario_id);
    }
    if (contentTypeModel === 'honorarioasimilado') {
      return plazasArr.filter((ap) => ap.honorario_asimilado_id);
    }
    return plazasArr.filter(
      (ap) => ap.empleado_id && !ap.becario_id && !ap.honorario_asimilado_id
        && !esEmpleadoSuspendido(ap.empleado_id),
    );
  };

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        nombre_empleado: e?.empleado,
        numero_empleado: e?.empleado,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const reduceImportes = (result, current) => {
    const tieneImporte = (current?.importe ?? 0) !== 0
      || (current?.importe_descuento ?? 0) !== 0
      || (current?.importe_patron ?? 0) !== 0
      || (current?.importe_trabajador ?? 0) !== 0
      || (current?.total ?? 0) !== 0;
    if (tieneImporte) {
      return result.concat(formatReceivedValues(current));
    }
    return result;
  };

  const basicKeys = [
    'nomina',
    'isr',
    'imss',
    'isn',
    'ipejal',
    'otros_pagos',
  ];
  const complexForms = [];

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);
      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const response = await API.get(baseURI, {
        params: { nomina: selected, page: cleanPage, ...(q ?? busquedaGuardada()) },
      });
      const results = formatReceivedClone(response.data.results || []);
      setSelectedRowKeys([]);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const ejecutarAuditoriaCompleta = async (allRecords, nominaId) => {
    try {
      // 1. Obtener detalles de percepciones, deducciones y descuentos para comprobar consistencia
      let percepcionesData = [];
      let deduccionesData = [];
      let descuentosData = [];
      let percepcionesCatalog = [];
      let deduccionesCatalog = [];
      let descuentosCatalog = [];

      try {
        const resP = await API.get(`/nominas/nominas-plazas-percepciones-vista-optimized/${nominaId}`);
        percepcionesData = resP.data?.results || resP.data || [];
        const resPCat = await API.get('/nominas/percepciones/');
        percepcionesCatalog = resPCat.data?.results || resPCat.data || [];
      } catch (e) { console.error('Error cargando detalles de percepciones para auditoría', e); }

      try {
        const resD = await API.get(`/nominas/nominas-plazas-deducciones-vista-optimized/${nominaId}`);
        deduccionesData = resD.data?.results || resD.data || [];
        const resDCat = await API.get('/nominas/deducciones/');
        deduccionesCatalog = resDCat.data?.results || resDCat.data || [];
      } catch (e) { console.error('Error cargando detalles de deducciones para auditoría', e); }

      try {
        const resDesc = await API.get(`/nominas/nominas-plazas-descuentos-vista-optimized/${nominaId}`);
        descuentosData = resDesc.data?.results || resDesc.data || [];
        const resDescCat = await API.get('/nominas/descuentos/');
        descuentosCatalog = resDescCat.data?.results || resDescCat.data || [];
      } catch (e) { console.error('Error cargando detalles de descuentos para auditoría', e); }

      const percepcionesMap = percepcionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
      const deduccionesMap = deduccionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
      const descuentosMap = descuentosCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});

      // Agrupar detalles por nomina_plaza_id
      const percepcionesPorPlaza = {};
      percepcionesData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!percepcionesPorPlaza[plazaId]) percepcionesPorPlaza[plazaId] = [];
        percepcionesPorPlaza[plazaId].push(item);
      });

      const deduccionesPorPlaza = {};
      deduccionesData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!deduccionesPorPlaza[plazaId]) deduccionesPorPlaza[plazaId] = [];
        deduccionesPorPlaza[plazaId].push(item);
      });

      const descuentosPorPlaza = {};
      descuentosData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!descuentosPorPlaza[plazaId]) descuentosPorPlaza[plazaId] = [];
        descuentosPorPlaza[plazaId].push(item);
      });

      // Detectar nombres de columnas de conceptos con valor > 0
      const percepcionesConValores = new Set();
      percepcionesData.forEach((item) => {
        const importe = parseFloat(item.importe) || 0;
        if (importe !== 0) {
          const percepcion = percepcionesMap[item.percepcion_id];
          if (percepcion && percepcion.descripcion) {
            const clave = percepcion.clave || '';
            const nombreColumna = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
            percepcionesConValores.add(nombreColumna);
          }
        }
      });
      const nombresPercepciones = Array.from(percepcionesConValores).sort();

      const deduccionesConValores = new Set();
      deduccionesData.forEach((item) => {
        const importe = parseFloat(item.importe) || 0;
        if (importe !== 0) {
          const deduccion = deduccionesMap[item.deduccion_id];
          if (deduccion && deduccion.concepto) {
            const clave = deduccion.clave || '';
            const nombreColumna = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
            deduccionesConValores.add(nombreColumna);
          }
        }
      });
      const nombresDeducciones = Array.from(deduccionesConValores).sort();

      const descuentosConValores = new Set();
      descuentosData.forEach((item) => {
        const importe = parseFloat(item.importe_descuento) || 0;
        if (importe !== 0) {
          const descuento = descuentosMap[item.descuento_id];
          if (descuento && descuento.clave_y_concepto) {
            descuentosConValores.add(descuento.clave_y_concepto);
          }
        }
      });
      const nombresDescuentos = Array.from(descuentosConValores).sort();

      const auditResults = [];
      let totalOtrosPagos = 0;
      let countOtrosPagos = 0;

      allRecords.forEach((r) => {
        const plazaId = r.id;
        const netBackend = parseFloat(r.importe_neto) || 0;
        const pBackend = parseFloat(r.importe_percepciones) || 0;
        const dBackend = parseFloat(r.importe_deducciones) || 0;
        const descBackend = parseFloat(r.importe_descuentos) || 0;
        const otrosBackend = parseFloat(r.importe_otros_pagos) || 0;

        // Simular mapeo a celdas del Excel para Percepciones
        const percepcionesPlaza = percepcionesPorPlaza[plazaId] || [];
        const percepcionesValores = {};
        nombresPercepciones.forEach((p) => { percepcionesValores[p] = 0; });
        percepcionesPlaza.forEach((item) => {
          const importe = parseFloat(item.importe) || 0;
          if (importe !== 0) {
            const percepcion = percepcionesMap[item.percepcion_id];
            if (percepcion && percepcion.descripcion) {
              const clave = percepcion.clave || '';
              const nombreColumna = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
              if (Object.hasOwn(percepcionesValores, nombreColumna)) {
                percepcionesValores[nombreColumna] += importe;
              }
            }
          }
        });

        // Simular mapeo a celdas del Excel para Deducciones
        const deduccionesPlaza = deduccionesPorPlaza[plazaId] || [];
        const deduccionesValores = {};
        nombresDeducciones.forEach((d) => { deduccionesValores[d] = 0; });
        deduccionesPlaza.forEach((item) => {
          const importe = parseFloat(item.importe) || 0;
          if (importe !== 0) {
            const deduccion = deduccionesMap[item.deduccion_id];
            if (deduccion && deduccion.concepto) {
              const clave = deduccion.clave || '';
              const nombreColumna = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
              if (Object.hasOwn(deduccionesValores, nombreColumna)) {
                deduccionesValores[nombreColumna] += importe;
              }
            }
          }
        });

        // Simular mapeo a celdas del Excel para Descuentos
        const descuentosPlaza = descuentosPorPlaza[plazaId] || [];
        const descuentosValores = {};
        nombresDescuentos.forEach((d) => { descuentosValores[d] = 0; });
        descuentosPlaza.forEach((item) => {
          const importe = parseFloat(item.importe_descuento) || 0;
          if (importe !== 0) {
            const descuento = descuentosMap[item.descuento_id];
            if (descuento && descuento.clave_y_concepto) {
              if (Object.hasOwn(descuentosValores, descuento.clave_y_concepto)) {
                descuentosValores[descuento.clave_y_concepto] += importe;
              }
            }
          }
        });

        // Sumar los valores mapeados en el Excel para comprobar que coincidan con los totales de cabecera
        let pExcelSuma = 0;
        Object.values(percepcionesValores).forEach((val) => { pExcelSuma += val; });
        let dExcelSuma = 0;
        Object.values(deduccionesValores).forEach((val) => { dExcelSuma += val; });
        let descExcelSuma = 0;
        Object.values(descuentosValores).forEach((val) => { descExcelSuma += val; });

        // Comprobar si hay discrepancias entre los totales del backend de la plaza y la simulación del Excel
        const tieneDiffPercepciones = Math.abs(pBackend - pExcelSuma) > 0.02;
        const tieneDiffDeducciones = Math.abs(dBackend - dExcelSuma) > 0.02;
        const tieneDiffDescuentos = Math.abs(descBackend - descExcelSuma) > 0.02;

        // Comprobar consistencia del Neto a Pagar
        const netoCalculadoExcel = netBackend; // El Excel ya usa netBackend directamente
        const netoFormulaRealSAT = pBackend - dBackend - descBackend + otrosBackend;
        const tieneDiffNetoRealSAT = Math.abs(netBackend - netoFormulaRealSAT) > 0.02;

        if (otrosBackend > 0) {
          countOtrosPagos++;
          totalOtrosPagos += otrosBackend;
        }

        if (tieneDiffPercepciones || tieneDiffDeducciones || tieneDiffDescuentos || tieneDiffNetoRealSAT) {
          auditResults.push({
            Empleado: r.numero_y_nombre_completo || r.nombre || plazaId,
            'Neto Backend': netBackend,
            'Neto Excel': netoCalculadoExcel,
            'Neto Fórmula Real SAT': netoFormulaRealSAT.toFixed(2),
            'Percepciones (Backend vs Excel)': `${pBackend.toFixed(2)} vs ${pExcelSuma.toFixed(2)}`,
            'Deducciones (Backend vs Excel)': `${dBackend.toFixed(2)} vs ${dExcelSuma.toFixed(2)}`,
            'Descuentos (Backend vs Excel)': `${descBackend.toFixed(2)} vs ${descExcelSuma.toFixed(2)}`,
            'Otros Pagos': otrosBackend,
          });
        }
      });
    } catch (err) {
      console.error('Error al ejecutar auditoría completa', err);
    }
  };

  // Carga inicial: datos paginados + TODOS los registros de esta nómina para Excel
  const fetchData = async () => {
    if (!selected) return;
    setLoading(true);
    try {
      // 1. Datos paginados para la tabla (primera página)
      const paginatedResponse = await API.get(baseURI, { params: { nomina: selected, page: 1 } });
      const paginatedResults = formatReceivedClone(paginatedResponse.data.results || []);
      setData({ ...paginatedResponse.data, results: paginatedResults });
      const fullResponse = await API.get(`/nominas/nominas-plazas-vista-optimized/${selected}/`);
      const rawData = fullResponse.data?.results || fullResponse.data || [];
      const allRecords = formatReceivedClone(rawData);
      setFullData(allRecords);

      // Ejecutar auditoría completa automáticamente
      if (allRecords.length > 0) {
        ejecutarAuditoriaCompleta(allRecords, selected);
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selected]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _plazas,
        _empleados,
        _datosOperacionalesEmpleados,
        _puestos,
        _admins,
        _tabuladoresNominales,
        _origen_del_recurso_sat,
        _bancos,
      ] = await Promise.all([
        getPlazasvistaOptimized(),
        getEmpleadosWithoutFilter(),
        getDatoOperacionalesDeEmpleados(),
        getPuestos(),
        getAdministracionDePlazasvistaOptimized(),
        getTabuladoresNominales({ estados_globales: ESTATUS_AUTORIZADO }),
        getOrigenesRecursosNominas(),
        getBancos(),
      ]);
      if (mounted) {
        setPlazas(_plazas);
        setEmpleados(_empleados);
        setEmpleadosDatosOperacionales(_datosOperacionalesEmpleados);
        setPuestos(_puestos);
        setAdminPlazas(_admins);
        setTabuladoresNominales(_tabuladoresNominales);
        setOrigenDelRecurso(_origen_del_recurso_sat);
        setBancos(_bancos);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    const fetchPlazasActualizadas = async () => {
      if (encabezado?.fecha_final_calculos) {
        setLoading(true);
        const paginatedData = await getNominasPlazas({ nomina: selected, ...busquedaGuardada() });
        const results = formatReceivedClone(paginatedData.results || []);
        setData({ ...paginatedData, results });
        setLoading(false);
      }
    };
    fetchPlazasActualizadas();
  }, [encabezado?.fecha_final_calculos]);

  useEffect(() => {
    if (calculando) {
      setProgresoCalculo({ calculadas: 0, total: data?.count || 0 });
    }
  }, [calculando]);

  useEffect(() => {
    const mapaEstados = {
      1: 'Activo',
      2: 'En Proceso',
      3: 'Inactivo',
      4: 'Autorizado',
      5: 'Cancelado',
      6: 'Rechazado',
    };
    const estadosInvalidos = [3, 5, 6];

    const revisarEstadoDeCalculo = async () => {
      try {
        // Endpoint liviano: cuenta NominaPlaza.eliminado=false en tiempo real
        const progreso = await getProgresoCalculo(encabezado?.id);
        if (!progreso) return;

        setProgresoCalculo((prev) => ({
          calculadas: progreso.calculadas ?? prev.calculadas,
          total: progreso.total || prev.total || data?.count || 0,
        }));

        if (estadosInvalidos.includes(progreso.estados_globales)) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          onSetCalculando(false);
          const estadoDesc = mapaEstados[progreso.estados_globales] || 'Estado desconocido';
          notification.warning({
            message: 'Cálculo detenido',
            description: `La nómina ${progreso.numero_nomina} está en estado "${estadoDesc}" y no continuará con el cálculo.`,
            placement: 'topRight',
            duration: 0,
          });
          return;
        }

        if (progreso.terminado) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          // Traer datos completos solo al terminar
          const updated = await getCalculoDeNomina(encabezado?.id);
          onEncabezadoUpdate(formatReceivedClone(updated));
          const [_data, _origenes] = await Promise.all([
            getNominasPlazas({ nomina: updated?.id, ...busquedaGuardada() }),
            getNominasOrigenesRecursos({ nomina: updated?.id }),
          ]);
          setData(formatReceivedClone(_data));
          onSetOrigenesRecursos(_origenes);
          fetchEncabezado();
          onSetCalculando(false);
          setProgresoCalculo({ calculadas: 0, total: 0 });
          // refresca el Historial de Errores en el padre justo cuando el
          // cálculo realmente terminó (progreso.terminado), no cuando
          // nomina_calculada cambia de valor, que puede estar desfasado
          await onCalculoTerminado?.(updated?.id);
          notification.success({
            message: 'Cálculo completado',
            description: `La nómina ${updated.numero_nomina} ha finalizado su cálculo.`,
            placement: 'topRight',
            duration: 0,
          });
        }
      } catch (error) {
        onError(error, setLoading);
      }
    };

    if (encabezado?.id && !encabezado?.fecha_final_calculos) {
      intervalRef.current = setInterval(revisarEstadoDeCalculo, 5000);
    }
    return () => clearInterval(intervalRef.current);
  }, [
    encabezado?.id,
    encabezado?.fecha_final_calculos,
    onEncabezadoUpdate,
    onSetCalculando,
    onSetOrigenesRecursos,
    onCalculoTerminado,
    fetchEncabezado,
  ]);

  // Polling — importación Excel de DED-02 - IMSS Trabajador en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPollingImportDeduccionIMSS) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingImportDeduccionIMSSRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR_DEDUCCION_IMSS,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImportDeduccionIMSS({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportDeduccionIMSSRef.current);
          pollingImportDeduccionIMSSRef.current = null;
          setIsPollingImportDeduccionIMSS(false);
          setProgresoImportDeduccionIMSS({ en_curso: 0, total: 0 });

          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Importar Deduccion IMSS (Resultado).xlsx';
            link.click();
            URL.revokeObjectURL(url);
          }

          notification.success({
            message: 'Importación completada',
            description: 'La carga de la deducción DED-02 - IMSS Trabajador finalizó. Se descargó el archivo de resultado.',
            placement: 'topRight',
            duration: 6,
          });

          const _data = await getNominasPlazas({ nomina: selected, ...busquedaGuardada() });
          setData(formatReceivedClone(_data));
          fetchEncabezado();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación deducción IMSS] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportDeduccionIMSSRef.current) {
        clearInterval(pollingImportDeduccionIMSSRef.current);
        pollingImportDeduccionIMSSRef.current = null;
      }
    };
  }, [isPollingImportDeduccionIMSS]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setNombreEmpleado('');
    setPuesto('');
    setPlaza('');
    setArea('');
    setRfc('');
    setCurp('');
    setNss('');
    setSindicato('');
    setTabuladorNominal('');
    setFechaDeAltaEmpleado('');
    setSueldoDiario('');
    setBancoPago('');
    setNumeroCuenta('');
    setMutable(true);
    setNombre('');
    setVisible(false);
    setNominaPlaza();
    setNominasPlazasPercepciones([]);
    setNominasPlazasDeducciones([]);
    setNominasPlazasDescuentos([]);
    setNominasPlazasOtrosPagos([]);
    form.resetFields();
  };

  const onClickVerRecibo = async () => {
    if (!nominaPlaza?.id) {
      message.warning('No se ha seleccionado un registro válido.');
      return;
    }
    setLoadingPdfModal(true);
    setShowPdfModal(true);
    const values = {
      ID: 2001,
      Parametros: [
        {
          Nombre: 'plazaid',
          TipoParametro: 'Entero',
          Valor: nominaPlaza.id,
        },
      ],
    };
    try {
      const fileBase64 = await postObtenerReporte(values);
      if (fileBase64) {
        setPdfBase64(fileBase64);
      } else {
        message.error('Error al generar el reporte.');
        setShowPdfModal(false);
      }
    } catch (error) {
      message.error('Error al cargar el recibo.');
      setShowPdfModal(false);
    } finally {
      setLoadingPdfModal(false);
    }
  };

  const onClosePdfModal = () => {
    setShowPdfModal(false);
    setPdfBase64('');
  };

  const onClickDetalle = async () => {
    setLoading(true);
    try {
      const [key] = selectedRowKeys;

      // 1. Traemos el detalle de la plaza (que ya incluye la información aplanada del empleado)
      const _detalle = await getNominaPlaza(key);
      if (!_detalle) {
        setLoading(false);
        return;
      }

      // 2. Ejecutamos únicamente las peticiones de los detalles tabulares de las pestañas inferiores
      const [
        _nominasPlazasPercepciones,
        _nominasPlazasDeducciones,
        _nominasPlazasDescuentos,
        _nominasPlazasOtrosPagos,
        _ImssNominas,
      ] = await Promise.all([
        getNominasPlazasPercepciones({ nomina_plaza: _detalle.id }),
        getNominasPlazasDeducciones({ nomina_plaza: _detalle.id }),
        getNominasPlazasDescuentos({ nomina_plaza: _detalle.id }),
        getNominasPlazasOtrosPagos({ nomina_plaza: _detalle.id }),
        getImssNominas({ nomina_plaza: _detalle.id }),
      ]);

      // 3. Mapeamos el Banco utilizando el catálogo 'bancos' cargado en el estado inicial
      const bancoObj = bancos.find((b) => b.id === _detalle.banco);
      const banco = bancoObj ? bancoObj.nombre : '';

      // 4. Mapeamos textos, claves y la nueva fecha de alta directa desde el backend
      const plazaString = _detalle.plaza_clave_y_descripcion || '';
      const areaString = _detalle.directorio_de_area_clave_y_nombre || _detalle.directorio_de_area_nombre || '—';
      const puestoString = _detalle.puesto_clave_y_descripcion || '';
      const empleadoString = _detalle.empleado_numero_y_nombre_completo || _detalle.numero_y_nombre_completo || '';
      const sueldoDiarioLocal = _detalle.sueldo_tabular_nominal || 0;
      const cuentaContable = _detalle.requiere_cuenta_contable_especifica ? _detalle.cuenta_contable_para_retencion_de_pago : '';

      // Formateamos la fecha de alta nativa que envía el serializador (asumiendo formato YYYY-MM-DD del backend)
      const fechaAlta = _detalle.fecha_de_alta
        ? moment(_detalle.fecha_de_alta).format('DD/MM/YYYY')
        : '—';

      const periodoDetalleInfo = periodosNominasDetalles?.find(
        (pd) => pd.id === encabezado?.periodo_de_nomina_detalle,
      );
      const periodoNomina = encabezado?.numero_nomina
        ? `${encabezado.numero_nomina} - ${periodoDetalleInfo?.numero_de_nomina || ''} (${moment(encabezado.fecha_inicial_nomina).format('DD/MM/YYYY')} AL ${moment(encabezado.fecha_final_nomina).format('DD/MM/YYYY')})`
        : '';

      // 5. Llenamos las tablas inferiores
      setNominasPlazasPercepciones(Array.isArray(_nominasPlazasPercepciones) ? _nominasPlazasPercepciones.reduce(reduceImportes, []) : []);
      setNominasPlazasDeducciones(Array.isArray(_nominasPlazasDeducciones) ? _nominasPlazasDeducciones.reduce(reduceImportes, []) : []);
      setNominasPlazasDescuentos(Array.isArray(_nominasPlazasDescuentos) ? _nominasPlazasDescuentos.reduce(reduceImportes, []) : []);
      setNominasPlazasOtrosPagos(Array.isArray(_nominasPlazasOtrosPagos) ? _nominasPlazasOtrosPagos.reduce(reduceImportes, []) : []);
      setImssNominas(Array.isArray(_ImssNominas) ? _ImssNominas.reduce(reduceImportes, []) : []);

      // 6. Seteamos los campos del Formulario Principal de Ant Design
      form.setFieldsValue({
        fecha: encabezado?.fecha_de_calculo ? moment(encabezado.fecha_de_calculo) : null,
        periodo_nomina: periodoNomina,
        empleado: empleadoString,
        puesto: puestoString,
        plaza: plazaString,
        area: areaString,
        rfc: _detalle.rfc || '',
        curp: _detalle.curp || '',
        nss: _detalle.numero_de_seguridad_social || '',
        fecha_alta: fechaAlta,
        sueldo_diario: sueldoDiarioLocal,
        banco_pago: banco,
        numero_cuenta: _detalle.clabe || _detalle.numero_tarjeta || '',
        cuenta_contable_retencion_pago: cuentaContable,
        sindicato: _detalle.sindicato_clave_descripcion || '',
        tipo_de_empleado_presupuestal: _detalle.tipo_de_empleado_presupuestal_descripcion
          || _detalle.tipo_de_empleado_presupuestal || '',
      });

      // 7. Actualizamos los estados locales que alimentan las vistas y textos del modal
      setNombreEmpleado(empleadoString);
      setPuesto(puestoString);
      setPlaza(plazaString);
      setArea(areaString);
      setRfc(_detalle.rfc || '');
      setCurp(_detalle.curp || '');
      setNss(_detalle.numero_de_seguridad_social || '');
      setSindicato(_detalle.sindicato_clave_descripcion || '');
      setFechaDeAltaEmpleado(fechaAlta);
      setSueldoDiario(sueldoDiarioLocal);
      setBancoPago(banco);
      setNumeroCuenta(_detalle.clabe || _detalle.numero_tarjeta || '');
      setNominaPlaza(_detalle);

      setVisible(true);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(formatReceived(record));
  };

  const showMsg = makeMessager(setCurrentTabKey);
  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const onClickEliminarPlaza = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteNominaPlaza(key);
        if (deleted) {
          setVisibleEliminar(false);
          const _data = await getNominasPlazas({ nomina: selected, ...busquedaGuardada() });
          setData(formatReceivedClone(_data));
          fetchEncabezado();
          onCancel();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickDelete = () => {
    setVisibleEliminar(true);
  };

  const onClickAdd = () => {
    setVisibleAgregar(true);
  };

  const agregarNominaPlaza = async () => {
    try {
      setLoading(true);
      await formPlaza.validateFields();
      const values = {
        ...formPlaza.getFieldsValue(),
      };
      const _admin = adminPlazas.find((e) => e.id === values?.plaza_id);
      if (esEmpleadoSuspendido(_admin?.empleado_id)) {
        message.error('No se puede agregar: el empleado está Suspendido. Un empleado Suspendido no debe ser calculado en nómina.');
        setLoading(false);
        return;
      }
      values.plaza = _admin?.plaza_id;
      values.empleado = _admin?.empleado_id;
      values.becario = _admin?.becario_id || null;
      values.honorario_asimilado = _admin?.honorario_asimilado_id || null;
      values.puesto = _admin?.puesto_id;
      values.nomina = encabezado?.id;
      values.tipo_de_estatus_timbrado = 1;
      values.origen_recurso_nomina = 1;
      const saved = await postNominaPlaza(values);
      if (saved) {
        const _data = await getNominasPlazas({ nomina: selected, ...busquedaGuardada() });
        setData(formatReceivedClone(_data));
        setVisibleAgregar(false);
        setNombre('');
        formPlaza.resetFields(['plaza_id']);
        fetchEncabezado();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickPreview = async () => {
    if (!nominaPlaza?.id) {
      message.warning('No se ha seleccionado un registro válido.');
      return;
    }
    setLoadingPdf(true);
    const values = {
      ID: 2001,
      Parametros: [
        {
          Nombre: 'plazaid',
          TipoParametro: 'Entero',
          Valor: nominaPlaza.id,
        },
      ],
    };
    try {
      const fileBase64 = await postObtenerReporte(values);
      if (fileBase64) {
        const downloadLink = document.createElement('a');
        const nombreLimpio = nombreEmpleado
          ? nombreEmpleado.replace(/[:*?"<>|]/g, '')
          : sujetoLabels.singular;
        const fileName = `Recibo_Nomina_${nominaPlaza.id}_${nombreLimpio}.pdf`;
        downloadLink.href = fileBase64;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        message.error('Error al generar el reporte.');
      }
    } catch (error) {
      onError(error);
    } finally {
      setLoadingPdf(false);
    }
  };

  const columns = [
    {
      titleText: 'No. de Plaza',
      dataIndex: 'plaza_no',
      key: 'plaza_no',
      width: 200,
    },
    {
      titleText: `No. de ${sujetoLabels.singular}`,
      dataIndex: 'empleado_numero',
      key: 'empleado_numero',
      width: 200,
    },
    {
      titleText: sujetoLabels.singular,
      dataIndex: 'empleado_numero_y_nombre_completo',
      key: 'empleado_numero_y_nombre_completo',
      width: 300,
    },
    {
      titleText: 'Tipo de Empleado Presupuestal',
      dataIndex: 'tipo_de_empleado_presupuestal_descripcion',
      key: 'tipo_de_empleado_presupuestal_descripcion',
      width: 250,
    },
    {
      titleText: 'Días Pagados',
      dataIndex: 'dias_trabajados',
      key: 'dias_trabajados',
      width: 230,
    },
    {
      titleText: 'Días Pagados Para CFDI',
      dataIndex: 'dias_pagados_para_cfdi',
      key: 'dias_pagados_para_cfdi',
      width: 230,
    },
    {
      titleText: `Sueldo Diario del ${sujetoLabels.singular}`,
      dataIndex: 'sueldo_tabular_nominal',
      key: 'sueldo_tabular_nominal',
      width: 230,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Percepciones',
      dataIndex: 'importe_percepciones',
      key: 'importe_percepciones',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Deducciones',
      dataIndex: 'importe_deducciones',
      key: 'importe_deducciones',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Descuentos',
      dataIndex: 'importe_descuentos',
      key: 'importe_descuentos',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe ISR',
      dataIndex: 'importe_isr',
      key: 'importe_isr',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe IMSS',
      dataIndex: 'importe_imss',
      key: 'importe_imss',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Neto',
      dataIndex: 'importe_neto',
      key: 'importe_neto',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  const onClickExportarCompleto = async () => {
    try {
      setLoading(true);
      message.info('Exportando TODOS los registros de esta nómina...');
      if (!selected) {
        message.error('No hay nómina seleccionada para exportar.');
        setLoading(false);
        return;
      }
      const response = await API.get(`/nominas/nominas-plazas-vista-optimized/${selected}/`);
      const rawData = response.data?.results || response.data || [];
      const allResults = formatReceivedClone(rawData);
      if (allResults.length === 0) {
        message.error('No se recibieron registros para esta nómina.');
        setLoading(false);
        return;
      }

      // 2. Obtener datos de percepciones, deducciones y descuentos
      let percepcionesData = [];
      let deduccionesData = [];
      let descuentosData = [];
      let percepcionesCatalog = [];
      let deduccionesCatalog = [];
      let descuentosCatalog = [];
      try {
        const percepcionesResponse = await API.get(`/nominas/nominas-plazas-percepciones-vista-optimized/${selected}`);
        percepcionesData = percepcionesResponse.data?.results || percepcionesResponse.data || [];
        const percepcionesCatalogResponse = await API.get('/nominas/percepciones/');
        percepcionesCatalog = percepcionesCatalogResponse.data?.results || percepcionesCatalogResponse.data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[exportación] no se pudieron cargar percepciones de la nómina ${selected}`, error);
      }
      try {
        const deduccionesResponse = await API.get(`/nominas/nominas-plazas-deducciones-vista-optimized/${selected}`);
        deduccionesData = deduccionesResponse.data?.results || deduccionesResponse.data || [];
        const deduccionesCatalogResponse = await API.get('/nominas/deducciones/');
        deduccionesCatalog = deduccionesCatalogResponse.data?.results || deduccionesCatalogResponse.data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[exportación] no se pudieron cargar deducciones de la nómina ${selected}`, error);
      }
      try {
        const descuentosResponse = await API.get(`/nominas/nominas-plazas-descuentos-vista-optimized/${selected}`);
        descuentosData = descuentosResponse.data?.results || descuentosResponse.data || [];
        const descuentosCatalogResponse = await API.get('/nominas/descuentos/');
        descuentosCatalog = descuentosCatalogResponse.data?.results || descuentosCatalogResponse.data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[exportación] no se pudieron cargar descuentos de la nómina ${selected}`, error);
      }
      const percepcionesMap = percepcionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
      const deduccionesMap = deduccionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
      const descuentosMap = descuentosCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
      const percepcionesPorPlaza = {};
      percepcionesData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!percepcionesPorPlaza[plazaId]) percepcionesPorPlaza[plazaId] = [];
        percepcionesPorPlaza[plazaId].push(item);
      });
      const deduccionesPorPlaza = {};
      deduccionesData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!deduccionesPorPlaza[plazaId]) deduccionesPorPlaza[plazaId] = [];
        deduccionesPorPlaza[plazaId].push(item);
      });
      const descuentosPorPlaza = {};
      descuentosData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!descuentosPorPlaza[plazaId]) descuentosPorPlaza[plazaId] = [];
        descuentosPorPlaza[plazaId].push(item);
      });

      // 5. Obtener todos los nombres únicos de columnas para organizarlas -- contando, por
      // plaza, cuantas veces se repite cada concepto base, para generar suficientes variantes
      // "... (2)", "... (3)" y que ninguna ocurrencia quede sin su propia columna.
      const maxOcurrenciasPercepciones = {};
      const contadorPercepcionesPorPlaza = {};
      percepcionesData.forEach((item) => {
        const percepcion = percepcionesMap[item.percepcion_id];
        if (percepcion && percepcion.descripcion) {
          const clave = percepcion.clave || '';
          const nombreBase = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
          const plazaId = item.nomina_plaza_id;
          if (!contadorPercepcionesPorPlaza[plazaId]) contadorPercepcionesPorPlaza[plazaId] = {};
          const ocurrencia = (contadorPercepcionesPorPlaza[plazaId][nombreBase] || 0) + 1;
          contadorPercepcionesPorPlaza[plazaId][nombreBase] = ocurrencia;
          maxOcurrenciasPercepciones[nombreBase] = Math.max(maxOcurrenciasPercepciones[nombreBase] || 0, ocurrencia);
        }
      });
      const maxOcurrenciasDeducciones = {};
      const contadorDeduccionesPorPlaza = {};
      deduccionesData.forEach((item) => {
        const deduccion = deduccionesMap[item.deduccion_id];
        if (deduccion && deduccion.concepto) {
          const clave = deduccion.clave || '';
          const nombreBase = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
          const plazaId = item.nomina_plaza_id;
          if (!contadorDeduccionesPorPlaza[plazaId]) contadorDeduccionesPorPlaza[plazaId] = {};
          const ocurrencia = (contadorDeduccionesPorPlaza[plazaId][nombreBase] || 0) + 1;
          contadorDeduccionesPorPlaza[plazaId][nombreBase] = ocurrencia;
          maxOcurrenciasDeducciones[nombreBase] = Math.max(maxOcurrenciasDeducciones[nombreBase] || 0, ocurrencia);
        }
      });
      const maxOcurrenciasDescuentos = {};
      const contadorDescuentosPorPlaza = {};
      descuentosData.forEach((item) => {
        const descuento = descuentosMap[item.descuento_id];
        if (descuento && descuento.clave_y_concepto) {
          const nombreBase = descuento.clave_y_concepto;
          const plazaId = item.nomina_plaza_id;
          if (!contadorDescuentosPorPlaza[plazaId]) contadorDescuentosPorPlaza[plazaId] = {};
          const ocurrencia = (contadorDescuentosPorPlaza[plazaId][nombreBase] || 0) + 1;
          contadorDescuentosPorPlaza[plazaId][nombreBase] = ocurrencia;
          maxOcurrenciasDescuentos[nombreBase] = Math.max(maxOcurrenciasDescuentos[nombreBase] || 0, ocurrencia);
        }
      });

      const columnasPercepciones = Object.keys(maxOcurrenciasPercepciones).sort().flatMap((nombreBase) => (
        Array.from({ length: maxOcurrenciasPercepciones[nombreBase] }, (_, i) => nombreColumnaConSufijo(nombreBase, i + 1))
      ));
      const columnasDeducciones = Object.keys(maxOcurrenciasDeducciones).sort().flatMap((nombreBase) => (
        Array.from({ length: maxOcurrenciasDeducciones[nombreBase] }, (_, i) => nombreColumnaConSufijo(nombreBase, i + 1))
      ));
      const columnasDescuentos = Object.keys(maxOcurrenciasDescuentos).sort().flatMap((nombreBase) => (
        Array.from({ length: maxOcurrenciasDescuentos[nombreBase] }, (_, i) => nombreColumnaConSufijo(nombreBase, i + 1))
      ));
      const excelData = allResults.map((record) => {
        const baseRecord = {
          ID: record.id || '',
          'Empleado ID': record.empleado_id || '',
          'Número y Nombre Completo': record.numero_y_nombre_completo || '',
          Nombre: record.nombre || '',
          'Apellido Paterno': record.apellido_paterno || '',
          'Apellido Materno': record.apellido_materno || '',
          [`Número de ${sujetoLabels.singular}`]: record.numero_de_empleado || '',
          [`Número de ${sujetoLabels.singular} Anterior`]: record.numero_de_empleado_anterior || '',
          'Código Postal Fiscal': record.codigo_postal_fiscal_texto_libre || '',
          CURP: record.curp || '',
          RFC: record.rfc || '',
          'Fecha de Nacimiento': record.fecha_de_nacimiento ? moment(record.fecha_de_nacimiento).format('DD/MM/YYYY') : '',
          'Tipo de Seguridad Social ID': record.tipo_de_seguridad_social_id || '',
          'Número de Seguridad Social': record.numero_de_seguridad_social || '',
          'Sueldo Diario': currencyFormatter(record.sueldo_diario || 0),
          'Sueldo Mensual': currencyFormatter(record.sueldo_mensual || 0),
          'Importe Deducciones': currencyFormatter(record.importe_deducciones || 0),
          'Importe Descuentos': currencyFormatter(record.importe_descuentos || 0),
          'Importe Percepciones': currencyFormatter(record.importe_percepciones || 0),
          'Importe IMSS SBC': currencyFormatter(record.importe_imss_sbc || 0),
          'Importe IMSS': currencyFormatter(record.importe_imss || 0),
          'Importe ISN': currencyFormatter(record.importe_isn || 0),
          'Importe ISR': currencyFormatter(record.importe_isr || 0),
          'ISR Base Exenta': currencyFormatter(record.importe_isr_base_excenta || 0),
          'ISR Base Gravable': currencyFormatter(record.importe_isr_base_gravable || 0),
          'ISR Base Gravable Anterior': currencyFormatter(record.importe_isr_base_gravable_anterior || 0),
          'ISR Base Gravable por Causar': currencyFormatter(record.importe_isr_base_gravable_por_causar || 0),
          'ISR Causado Previo': currencyFormatter(record.importe_isr_causado_previo || 0),
          'ISR Causado Total': currencyFormatter(record.importe_isr_causado_total || 0),
          'ISR Compensación': currencyFormatter(record.importe_isr_compensacion || 0),
          'ISR Cuota Fija': currencyFormatter(record.importe_isr_cuota_fija || 0),
          'ISR Excedente': currencyFormatter(record.importe_isr_excedente || 0),
          'ISR Impuesto Marginal': currencyFormatter(record.importe_isr_impuesto_marginal || 0),
          'ISR Límite Inferior': currencyFormatter(record.importe_isr_limite_inferior || 0),
          'ISR % Excedente': currencyFormatter(record.importe_isr_percent_excedente || 0),
          'ISR por Retener': currencyFormatter(record.importe_isr_por_retener || 0),
          'ISR Retenido': currencyFormatter(record.importe_isr_retenido || 0),
          'ISR Retenido Anterior': currencyFormatter(record.importe_isr_retenido_anterior || 0),
          'ISR Subtotal': currencyFormatter(record.importe_isr_subtotal || 0),
          'ISR Total Base Gravable': currencyFormatter(record.importe_isr_total_base_gravable || 0),
          Antiguedad: record.antiguedad || '',
          'Días Trabajados': record.dias_trabajados || '',
          'Requiere Cuenta Contable Específica': record.requiere_cuenta_contable_especifica ? 'Sí' : 'No',
          'Cuenta Contable Retención Pago ID': record.cuenta_contable_para_retencion_de_pago_id || '',
          'Plaza ID': record.plaza_id || '',
          'Banco ID': record.banco_id || '',
          'Importe Otros Pagos': currencyFormatter(record.importe_otros_pagos || 0),
          'Importe Neto': currencyFormatter(record.importe_neto || 0),
          'Importe Subsidio Causado Total': currencyFormatter(record.importe_subsidio_causado_total || 0),
          'Fecha de Creación': record.fecha_de_creacion ? moment(record.fecha_de_creacion).format('DD/MM/YYYY HH:mm:ss') : '',
          'Nómina ID': record.nomina_id || '',
          'Nómina Folio Agrupador': record.nomina_folio_agrupador || '',
          'Nómina Fecha Cálculo': record.nomina_fecha_calculo ? moment(record.nomina_fecha_calculo).format('DD/MM/YYYY') : '',
          'Puesto ID': record.puesto_id || '',
          'Método de Pago ID': record.metodo_de_pago_id || '',
          'Cuenta Bancaria': record.cuenta_bancaria || '',
          Estatus: record.estados_globales_descripcion || '',
          'Plaza No': record.plaza_no || '',
          'Plaza Descripción': record.plaza_descripcion || '',
          'Plaza Clave y Descripción': record.plaza_clave_y_descripcion || '',
          'Directorio Área ID': record.directorio_de_area_id || '',
          'Directorio Área Clave': record.directorio_de_area_clave || '',
          'Directorio Área Nombre': record.directorio_de_area_nombre || '',
          'Directorio Área Clave y Nombre': record.directorio_de_area_clave_y_nombre || '',
          'Puesto Clave': record.puesto_clave || '',
          'Puesto Clave y Descripción': record.puesto_clave_y_descripcion || '',
          'Origen Recurso Nómina': record.origen_recurso_nomina_nombre || '',
          'Periodo de Nómina': record.periodo_de_nomina || '',
          'Tipo de Nómina Empleado': record.tipo_de_nomina_empleado_descripcion || '',
          'Tipo de Empleado Presupuestal': record.tipo_de_empleado_presupuestal_descripcion || '',
          Descripción: record.descripcion || '',
        };
        columnasPercepciones.forEach((columna) => {
          baseRecord[`Percepción: ${columna}`] = '0.00';
        });
        const contadorPercepcionesRecord = {};
        percepcionesPorPlaza[record.id]?.forEach((percepcionItem) => {
          const percepcion = percepcionesMap[percepcionItem.percepcion_id];
          if (percepcion && percepcion.descripcion) {
            const clave = percepcion.clave || '';
            const nombreBase = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
            const ocurrencia = (contadorPercepcionesRecord[nombreBase] || 0) + 1;
            contadorPercepcionesRecord[nombreBase] = ocurrencia;
            const nombreColumna = nombreColumnaConSufijo(nombreBase, ocurrencia);
            baseRecord[`Percepción: ${nombreColumna}`] = currencyFormatter(percepcionItem.importe || 0);
          }
        });
        columnasDeducciones.forEach((columna) => {
          baseRecord[`Deducción: ${columna}`] = '0.00';
        });
        const contadorDeduccionesRecord = {};
        deduccionesPorPlaza[record.id]?.forEach((deduccionItem) => {
          const deduccion = deduccionesMap[deduccionItem.deduccion_id];
          if (deduccion && deduccion.concepto) {
            const clave = deduccion.clave || '';
            const nombreBase = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
            const ocurrencia = (contadorDeduccionesRecord[nombreBase] || 0) + 1;
            contadorDeduccionesRecord[nombreBase] = ocurrencia;
            const nombreColumna = nombreColumnaConSufijo(nombreBase, ocurrencia);
            baseRecord[`Deducción: ${nombreColumna}`] = currencyFormatter(deduccionItem.importe || 0);
          }
        });
        columnasDescuentos.forEach((columna) => {
          baseRecord[`Descuento: ${columna}`] = '0.00';
        });
        const contadorDescuentosRecord = {};
        descuentosPorPlaza[record.id]?.forEach((descuentoItem) => {
          const descuento = descuentosMap[descuentoItem.descuento_id];
          if (descuento && descuento.clave_y_concepto) {
            const nombreBase = descuento.clave_y_concepto;
            const ocurrencia = (contadorDescuentosRecord[nombreBase] || 0) + 1;
            contadorDescuentosRecord[nombreBase] = ocurrencia;
            const nombreColumna = nombreColumnaConSufijo(nombreBase, ocurrencia);
            baseRecord[`Descuento: ${nombreColumna}`] = currencyFormatter(descuentoItem.importe_descuento || 0);
          }
        });
        return baseRecord;
      });
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!views'] = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];
      if (excelData.length > 0) {
        const colWidths = Object.keys(excelData[0]).map((key) => ({
          wch: Math.max(key.length, ...excelData.map((row) => String(row[key] || '').length)) + 2,
        }));
        worksheet['!cols'] = colWidths;
      }
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'NominaPlazas');
      const fecha = moment().format('YYYY-MM-DD');
      const fileName = `Nomina_${encabezado?.numero_nomina || selected}_Completo_${fecha}.xlsx`;
      XLSX.writeFile(workbook, fileName);
      setLoading(false);
      message.success(`Exportados ${allResults.length} registros con detalle completo`);
    } catch (err) {
      message.error('Error al obtener los datos para exportar.');
      setLoading(false);
    }
  };

  const onClickExportarPorArea = async () => {
    const FORMATO_MONEDA_EXCEL = '"$"#,##0.00';
    const redondearMonto = (valor) => Math.round((Number(valor) || 0) * 100) / 100;
    try {
      setLoading(true);
      message.loading({ content: 'Generando reporte por áreas...', key: 'exportarArea' });
      if (!selected) {
        message.error('No hay nómina seleccionada');
        setLoading(false);
        return;
      }

      // Obtener todos los datos completos de la nómina
      const response = await API.get(`/nominas/nominas-plazas-vista-optimized/${selected}/`);
      const rawData = response.data?.results || response.data || [];
      const allRecords = formatReceivedClone(rawData);
      if (allRecords.length === 0) {
        message.error('No se encontraron registros para exportar');
        setLoading(false);
        return;
      }

      // Obtener datos de percepciones, deducciones y descuentos
      let percepcionesData = [];
      let deduccionesData = [];
      let descuentosData = [];
      let percepcionesCatalog = [];
      let deduccionesCatalog = [];
      let descuentosCatalog = [];

      try {
        const percepcionesResponse = await API.get(`/nominas/nominas-plazas-percepciones-vista-optimized/${selected}`);
        percepcionesData = percepcionesResponse.data?.results || percepcionesResponse.data || [];
        const percepcionesCatalogResponse = await API.get('/nominas/percepciones/');
        percepcionesCatalog = percepcionesCatalogResponse.data?.results || percepcionesCatalogResponse.data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[exportación por área] no se pudieron cargar percepciones de la nómina ${selected}`, error);
      }

      try {
        const deduccionesResponse = await API.get(`/nominas/nominas-plazas-deducciones-vista-optimized/${selected}`);
        deduccionesData = deduccionesResponse.data?.results || deduccionesResponse.data || [];
        const deduccionesCatalogResponse = await API.get('/nominas/deducciones/');
        deduccionesCatalog = deduccionesCatalogResponse.data?.results || deduccionesCatalogResponse.data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[exportación por área] no se pudieron cargar deducciones de la nómina ${selected}`, error);
      }

      try {
        const descuentosResponse = await API.get(`/nominas/nominas-plazas-descuentos-vista-optimized/${selected}`);
        descuentosData = descuentosResponse.data?.results || descuentosResponse.data || [];
        const descuentosCatalogResponse = await API.get('/nominas/descuentos/');
        descuentosCatalog = descuentosCatalogResponse.data?.results || descuentosCatalogResponse.data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[exportación por área] no se pudieron cargar descuentos de la nómina ${selected}`, error);
      }

      const percepcionesMap = percepcionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
      const deduccionesMap = deduccionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
      const descuentosMap = descuentosCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});

      // Agrupar por plaza para facilitar el acceso
      const percepcionesPorPlaza = {};
      percepcionesData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!percepcionesPorPlaza[plazaId]) percepcionesPorPlaza[plazaId] = [];
        percepcionesPorPlaza[plazaId].push(item);
      });

      const deduccionesPorPlaza = {};
      deduccionesData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!deduccionesPorPlaza[plazaId]) deduccionesPorPlaza[plazaId] = [];
        deduccionesPorPlaza[plazaId].push(item);
      });

      const descuentosPorPlaza = {};
      descuentosData.forEach((item) => {
        const plazaId = item.nomina_plaza_id;
        if (!descuentosPorPlaza[plazaId]) descuentosPorPlaza[plazaId] = [];
        descuentosPorPlaza[plazaId].push(item);
      });

      // Percepciones "líquidas": su Forma de Pago (Configurador de Percepciones, campo metodo_de_pago)
      // es Transferencia, Cheque o Efectivo -- no vales/monedero de despensa.
      let idsPercepcionesLiquidas = new Set();
      try {
        const metodosResponse = await API.get('/catalogos/metodos-de-pago/');
        const metodos = metodosResponse.data?.results || metodosResponse.data || [];
        const normalizar = (texto) => (texto || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const idsMetodosLiquidos = new Set(metodos
          .filter((m) => ['transferencia', 'cheque', 'efectivo'].some((palabra) => normalizar(m.concepto).includes(palabra)))
          .map((m) => m.id));
        idsPercepcionesLiquidas = new Set(percepcionesCatalog
          .filter((perc) => (perc.metodo_de_pago || []).some((id) => idsMetodosLiquidos.has(id)))
          .map((perc) => perc.id));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[exportación por área] no se pudieron cargar las formas de pago', error);
      }

      // === 1. DETECTAR SOLO PERCEPCIONES QUE TIENEN VALORES > 0 ===
      const percepcionesConValores = new Set();
      Object.values(percepcionesPorPlaza).forEach((plazaPercepciones) => {
        plazaPercepciones.forEach((item) => {
          const importe = parseFloat(item.importe) || 0;
          if (importe !== 0) {
            const percepcion = percepcionesMap[item.percepcion_id];
            if (percepcion && percepcion.descripcion) {
              const clave = percepcion.clave || '';
              const nombreColumna = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
              percepcionesConValores.add(nombreColumna);
            }
          }
        });
      });
      const nombresPercepciones = Array.from(percepcionesConValores).sort();

      // === 2. DETECTAR SOLO DEDUCCIONES QUE TIENEN VALORES > 0 ===
      const deduccionesConValores = new Set();
      Object.values(deduccionesPorPlaza).forEach((plazaDeducciones) => {
        plazaDeducciones.forEach((item) => {
          const importe = parseFloat(item.importe) || 0;
          if (importe !== 0) {
            const deduccion = deduccionesMap[item.deduccion_id];
            if (deduccion && deduccion.concepto) {
              const clave = deduccion.clave || '';
              const nombreColumna = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
              deduccionesConValores.add(nombreColumna);
            }
          }
        });
      });
      const nombresDeducciones = Array.from(deduccionesConValores).sort();

      // === 3. DETECTAR SOLO DESCUENTOS QUE TIENEN VALORES > 0 ===
      const descuentosConValores = new Set();
      Object.values(descuentosPorPlaza).forEach((plazaDescuentos) => {
        plazaDescuentos.forEach((item) => {
          const importe = parseFloat(item.importe_descuento) || 0;
          if (importe !== 0) {
            const descuento = descuentosMap[item.descuento_id];
            if (descuento && descuento.clave_y_concepto) {
              descuentosConValores.add(descuento.clave_y_concepto);
            }
          }
        });
      });
      const nombresDescuentos = Array.from(descuentosConValores).sort();

      // === 4. CONSTRUIR HEADERS DINÁMICAMENTE (solo con valores > 0) ===
      const headersBase = ['Número de Empleado', 'Empleado ID', 'Número y Nombre Completo', 'Tipo de Empleado Presupuestal'];
      // Títulos: solo el nombre del concepto (sin "Percepción:"/"Deducción:"/"Descuento:" ni la
      // clave), tomado del catálogo para no recortar nombres que traigan su propio guion.
      const conClave = (clave, texto) => (clave ? `${clave} - ${texto}` : texto);
      const soloConcepto = (titulo, catalogo, armarTitulo, campoTexto) => {
        const concepto = catalogo.find((c) => armarTitulo(c) === titulo);
        return concepto?.[campoTexto] || titulo;
      };
      const tituloPercepcion = (c) => conClave(c.clave, c.descripcion);
      const tituloDeduccion = (c) => conClave(c.clave, c.concepto);
      const tituloDescuento = (c) => c.clave_y_concepto;
      const headersPercepciones = nombresPercepciones
        .map((t) => soloConcepto(t, percepcionesCatalog, tituloPercepcion, 'descripcion'));
      const headersDeducciones = nombresDeducciones
        .map((t) => soloConcepto(t, deduccionesCatalog, tituloDeduccion, 'concepto'));
      const headersDescuentos = nombresDescuentos
        .map((t) => soloConcepto(t, descuentosCatalog, tituloDescuento, 'concepto'));
      const headersTotales = [
        'Total Percepciones',
        'Total Percepciones Líquidas',
        'Total Deducciones',
        'Total Descuentos',
        'Neto a Pagar',
      ];

      const headers = [...headersBase, ...headersPercepciones, ...headersDeducciones, ...headersDescuentos, ...headersTotales];

      // Agrupar por Directorio Área
      const areasMap = new Map();
      allRecords.forEach((record) => {
        const areaClaveNombre = record.directorio_de_area_clave_y_nombre
        || record.directorio_de_area_nombre
        || (record.directorio_de_area_clave ? `${record.directorio_de_area_clave} - Sin nombre` : 'Sin área');

        if (!areasMap.has(areaClaveNombre)) {
          areasMap.set(areaClaveNombre, { empleados: [] });
        }

        // Obtener valores de percepciones (solo las que tienen valores > 0 en general)
        const percepcionesPlaza = percepcionesPorPlaza[record.id] || [];
        const percepcionesValores = {};
        nombresPercepciones.forEach((p) => { percepcionesValores[p] = 0; });
        percepcionesPlaza.forEach((item) => {
          const importe = parseFloat(item.importe) || 0;
          if (importe !== 0) {
            const percepcion = percepcionesMap[item.percepcion_id];
            if (percepcion && percepcion.descripcion) {
              const clave = percepcion.clave || '';
              const nombreColumna = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
              if (Object.hasOwn(percepcionesValores, nombreColumna)) {
                percepcionesValores[nombreColumna] += importe;
              }
            }
          }
        });

        // Obtener valores de deducciones (solo las que tienen valores > 0 en general)
        const deduccionesPlaza = deduccionesPorPlaza[record.id] || [];
        const deduccionesValores = {};
        nombresDeducciones.forEach((d) => { deduccionesValores[d] = 0; });
        deduccionesPlaza.forEach((item) => {
          const importe = parseFloat(item.importe) || 0;
          if (importe !== 0) {
            const deduccion = deduccionesMap[item.deduccion_id];
            if (deduccion && deduccion.concepto) {
              const clave = deduccion.clave || '';
              const nombreColumna = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
              if (Object.hasOwn(deduccionesValores, nombreColumna)) {
                deduccionesValores[nombreColumna] += importe;
              }
            }
          }
        });

        // Obtener valores de descuentos (solo los que tienen valores > 0 en general)
        const descuentosPlaza = descuentosPorPlaza[record.id] || [];
        const descuentosValores = {};
        nombresDescuentos.forEach((d) => { descuentosValores[d] = 0; });
        descuentosPlaza.forEach((item) => {
          const importe = parseFloat(item.importe_descuento) || 0;
          if (importe !== 0) {
            const descuento = descuentosMap[item.descuento_id];
            if (descuento && descuento.clave_y_concepto) {
              if (Object.hasOwn(descuentosValores, descuento.clave_y_concepto)) {
                descuentosValores[descuento.clave_y_concepto] += importe;
              }
            }
          }
        });

        const percepcionesLiquidas = percepcionesPlaza
          .filter((item) => idsPercepcionesLiquidas.has(item.percepcion_id))
          .reduce((acc, item) => acc + (parseFloat(item.importe) || 0), 0);
        const importeDeducciones = parseFloat(record.importe_deducciones) || 0;
        const importeDescuentos = parseFloat(record.importe_descuentos) || 0;
        const importePercepciones = parseFloat(record.importe_percepciones) || 0;
        const netoAPagar = parseFloat(record.importe_neto) || 0;

        areasMap.get(areaClaveNombre).empleados.push({
          numeroDeEmpleado: record.numero_de_empleado || '',
          empleadoId: record.empleado_id || '',
          numeroYNombre: record.numero_y_nombre_completo || '',
          tipoEmpleadoPresupuestal: record.tipo_de_empleado_presupuestal_descripcion || '',
          percepcionesValores,
          deduccionesValores,
          descuentosValores,
          importeDeducciones,
          importeDescuentos,
          importePercepciones,
          percepcionesLiquidas,
          netoAPagar,
        });
      });

      // Preparar filas del Excel
      const excelRows = [];
      excelRows.push(['Sistema de Nomina']);
      excelRows.push(['Reporte de Percepciones y Deducciones']);
      excelRows.push([`Compañía: ${razonSocial}`]);
      excelRows.push([`Nomina: ${encabezado?.tipo_nomina || 'Nomina Quincenal'}`]);
      excelRows.push([`Periodo: ${encabezado?.fecha_inicial_nomina ? moment(encabezado.fecha_inicial_nomina).format('DD/MM/YYYY') : ''} al ${encabezado?.fecha_final_nomina ? moment(encabezado.fecha_final_nomina).format('DD/MM/YYYY') : ''}`]);
      excelRows.push(['Clave Movto.: NN Nómina Normal']);
      excelRows.push(['Tabla : captura']);
      excelRows.push([]);
      excelRows.push(headers);

      const totalGeneral = new Array(headers.length).fill(0);
      const sortedAreas = Array.from(areasMap.keys()).sort();

      sortedAreas.forEach((areaClaveNombre) => {
        const areaData = areasMap.get(areaClaveNombre);
        const totalArea = new Array(headers.length).fill(0);

        const deptoRow = new Array(headers.length).fill('');
        deptoRow[0] = `Departamento: ${areaClaveNombre.trim()}`;
        excelRows.push(deptoRow);

        areaData.empleados.forEach((empleado) => {
          const row = new Array(headers.length).fill('');
          let colIndex = 0;

          // Columnas base
          row[colIndex] = empleado.numeroDeEmpleado;
          colIndex += 1;
          row[colIndex] = empleado.empleadoId;
          colIndex += 1;
          row[colIndex] = empleado.numeroYNombre;
          colIndex += 1;
          row[colIndex] = empleado.tipoEmpleadoPresupuestal;
          colIndex += 1;

          // Percepciones
          nombresPercepciones.forEach((percepcion) => {
            const valor = empleado.percepcionesValores[percepcion] || 0;
            row[colIndex] = redondearMonto(valor);
            totalArea[colIndex] += valor;
            totalGeneral[colIndex] += valor;
            colIndex += 1;
          });

          // Deducciones
          nombresDeducciones.forEach((deduccion) => {
            const valor = empleado.deduccionesValores[deduccion] || 0;
            row[colIndex] = redondearMonto(valor);
            totalArea[colIndex] += valor;
            totalGeneral[colIndex] += valor;
            colIndex += 1;
          });

          // Descuentos
          nombresDescuentos.forEach((descuento) => {
            const valor = empleado.descuentosValores[descuento] || 0;
            row[colIndex] = redondearMonto(valor);
            totalArea[colIndex] += valor;
            totalGeneral[colIndex] += valor;
            colIndex += 1;
          });

          // Totales
          // Mismo orden que headersTotales
          const totales = [
            empleado.importePercepciones,
            empleado.percepcionesLiquidas,
            empleado.importeDeducciones,
            empleado.importeDescuentos,
            empleado.netoAPagar,
          ];
          totales.forEach((valor) => {
            row[colIndex] = redondearMonto(valor);
            totalArea[colIndex] += valor;
            totalGeneral[colIndex] += valor;
            colIndex += 1;
          });

          excelRows.push(row);
        });

        // Fila de total del departamento
        const totalDeptoRow = new Array(headers.length).fill('');
        totalDeptoRow[0] = `Total Depto: ${areaClaveNombre.trim()}`;
        for (let i = 3; i < headers.length; i += 1) {
          if (totalArea[i] !== 0) {
            totalDeptoRow[i] = redondearMonto(totalArea[i]);
          }
        }
        excelRows.push(totalDeptoRow);
        excelRows.push(new Array(headers.length).fill(''));
      });

      // Fila de total general
      const totalGeneralRow = new Array(headers.length).fill('');
      totalGeneralRow[0] = 'TOTAL GENERAL';
      for (let i = 3; i < headers.length; i += 1) {
        if (totalGeneral[i] !== 0) {
          totalGeneralRow[i] = redondearMonto(totalGeneral[i]);
        }
      }
      excelRows.push(totalGeneralRow);

      const worksheet = XLSX.utils.aoa_to_sheet(excelRows);
      // Montos como número con formato de moneda (no texto), para que Excel pueda sumarlos.
      // Las columnas base (número de empleado, ID, nombre, tipo) no llevan formato.
      const rango = XLSX.utils.decode_range(worksheet['!ref']);
      for (let fila = rango.s.r; fila <= rango.e.r; fila += 1) {
        for (let col = headersBase.length; col <= rango.e.c; col += 1) {
          const celda = worksheet[XLSX.utils.encode_cell({ r: fila, c: col })];
          if (celda && celda.t === 'n') celda.z = FORMATO_MONEDA_EXCEL;
        }
      }
      worksheet['!cols'] = headers.map(() => ({ wch: 35 }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'NominaPorArea');
      const fecha = moment().format('YYYY-MM-DD');
      const fileName = `Nomina_${encabezado?.numero_nomina || selected}_Por_Area_${fecha}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      setLoading(false);
      message.success({ content: 'Reporte por áreas generado exitosamente', key: 'exportarArea' });
    } catch (err) {
      message.error({ content: 'Error al generar el reporte por áreas', key: 'exportarArea' });
      setLoading(false);
    }
  };

  const onClickExportarDespensa = async () => {
    try {
      setLoading(true);
      message.loading({ content: 'Generando reporte de despensa...', key: 'exportarDespensa' });
      if (!selected) {
        message.error('No hay nómina seleccionada');
        setLoading(false);
        return;
      }

      // Obtener todos los datos completos en paralelo
      const [plazasResponse, percepcionesResponse, catalogResponse] = await Promise.all([
        API.get(`/nominas/nominas-plazas-vista-optimized/${selected}/`),
        API.get(`/nominas/nominas-plazas-percepciones-vista-optimized/${selected}`),
        API.get('/nominas/percepciones/'),
      ]);

      const rawData = plazasResponse.data?.results || plazasResponse.data || [];
      const allRecords = formatReceivedClone(rawData);
      const percepcionesData = percepcionesResponse.data?.results || percepcionesResponse.data || [];
      const catalog = catalogResponse.data?.results || catalogResponse.data || [];

      if (allRecords.length === 0) {
        message.error('No se encontraron registros para exportar');
        setLoading(false);
        return;
      }

      // Buscar ID de la percepción P106
      const targetPercepcion = catalog.find((p) => p.clave === 'P106');
      if (!targetPercepcion) {
        message.error({ content: 'No se encontró la percepción P106 en el catálogo', key: 'exportarDespensa' });
        setLoading(false);
        return;
      }
      const targetPercepcionId = targetPercepcion.id;

      // Mapear importe despensa por plaza ID (record.id)
      const despensaMap = new Map();
      percepcionesData.forEach((item) => {
        if (item.percepcion_id === targetPercepcionId) {
          despensaMap.set(item.nomina_plaza_id, parseFloat(item.importe) || 0);
        }
      });

      const excelRows = [];

      // Cabecera
      excelRows.push([razonSocial]);
      excelRows.push([
        `Periodo: ${encabezado?.fecha_inicial_nomina ? moment(encabezado.fecha_inicial_nomina).format('DD/MM/YYYY') : ''} al ${encabezado?.fecha_final_nomina ? moment(encabezado.fecha_final_nomina).format('DD/MM/YYYY') : ''}`,
      ]);
      excelRows.push(['Reporte de Monedero Electrónico de Despensa']);
      excelRows.push([]);

      // Encabezados de columnas
      const headers = [
        `Número del ${sujetoLabels.singular}`,
        `Nombre del ${sujetoLabels.singular}`,
        'Importe del Pago de Monedero Electrónico',
      ];
      excelRows.push(headers);

      let totalImporte = 0;

      // Filtrar y mapear datos de los empleados que tienen importe despensa > 0
      allRecords.forEach((record) => {
        const importe = despensaMap.get(record.id) || 0;
        if (importe > 0) {
          totalImporte += importe;
          const nombreCompleto = `${record.nombre || ''} ${record.apellido_paterno || ''} ${record.apellido_materno || ''}`.trim();
          const empNombre = nombreCompleto || record.numero_y_nombre_completo || '';
          excelRows.push([
            record.numero_de_empleado || '',
            empNombre,
            importe,
          ]);
        }
      });

      if (excelRows.length <= 5) {
        message.warning({ content: 'No se encontraron empleados con pago de despensa P106', key: 'exportarDespensa' });
        setLoading(false);
        return;
      }

      // Fila de Total
      excelRows.push([]);
      const totalRow = new Array(headers.length).fill('');
      totalRow[0] = 'TOTAL';
      totalRow[2] = totalImporte;
      excelRows.push(totalRow);

      const worksheet = XLSX.utils.aoa_to_sheet(excelRows);

      // Dar formato de moneda/número a las celdas numéricas de la columna C (índice 2)
      const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:C1');
      for (let r = 5; r <= range.e.r; r += 1) {
        const cellRef = XLSX.utils.encode_cell({ r, c: 2 });
        if (worksheet[cellRef] && typeof worksheet[cellRef].v === 'number') {
          worksheet[cellRef].t = 'n';
          worksheet[cellRef].z = '"$"#,##0.00';
        }
      }

      // Congelar fila de encabezado (las primeras 5 filas)
      worksheet['!views'] = [{ state: 'frozen', xSplit: 0, ySplit: 5 }];

      // Ajustar anchos de columna automáticamente
      const colWidths = headers.map((header, colIdx) => {
        const lengths = excelRows.map((r) => {
          const val = r[colIdx];
          if (typeof val === 'number') {
            return String(val).length + 6;
          }
          return String(val || '').length;
        });
        return { wch: Math.max(header.length, ...lengths) + 3 };
      });
      worksheet['!cols'] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'ReporteDespensa');

      const fecha = moment().format('YYYY-MM-DD');
      const fileName = `Reporte_Despensa_${encabezado?.numero_nomina || selected}_${fecha}.xlsx`;

      XLSX.writeFile(workbook, fileName);

      message.destroy();
      message.success({ content: 'Reporte de despensa generado correctamente', key: 'exportarDespensa' });
    } catch (err) {
      console.error(err);
      message.destroy();
      message.error({ content: 'Error al generar el reporte de despensa', key: 'exportarDespensa' });
    } finally {
      setLoading(false);
    }
  };

  const handleExportConfirm = async (options) => {
    setShowExportModal(false);
    if (options.exportType === 'completo') {
      onClickExportarCompleto();
    } else if (options.exportType === 'porArea') {
      onClickExportarPorArea();
    } else if (options.exportType === 'personalizado') {
      // Refresca fullData antes de abrir el exportador: un recálculo de la
      // nómina no actualiza fullData por sí solo (solo refresca la tabla
      // paginada), así que sin este refetch se podría exportar data vieja.
      await fetchData();
      setShowExportadorPersonalizado(true);
    } else if (options.exportType === 'despensa') {
      onClickExportarDespensa();
    }
  };

  const onClickExportarExcel = () => {
    setShowExportModal(true);
  };

  const onClickCargarDeduccionIMSS = () => {
    setVisibleModalImportarDeduccionIMSS(true);
  };

  const onClickObtenerPlantillaDeduccionIMSS = () => {
    const filaVacia = {
      [sujetoLabels.singular]: '',
      'Importe DED-02 - IMSS TRABAJADOR': '',
      'DED-01 - ISR SUELDOS': '',
      'P101 - SUELDO': '',
    };

    const filas = (data?.results || []).map((row) => ({
      [sujetoLabels.singular]: row.empleado_numero || '',
      'Importe DED-02 - IMSS TRABAJADOR': '',
      'DED-01 - ISR SUELDOS': '',
      'P101 - SUELDO': '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(filas.length ? filas : [filaVacia]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla');
    XLSX.writeFile(workbook, `Importar_Deduccion_IMSS_${encabezado?.numero_nomina || selected}.xlsx`);
  };

  const onUploadDeduccionIMSS = async () => {
    try {
      await formCargaDeduccionIMSS.validateFields();
      const { file } = formCargaDeduccionIMSS.getFieldsValue();
      if (file) {
        setLoading(true);
        const response = await importarDeduccionIMSS(selected, file.file);

        if (response?.status === 202) {
          setVisibleModalImportarDeduccionIMSS(false);
          formCargaDeduccionIMSS.resetFields();
          setProgresoImportDeduccionIMSS({ en_curso: 0, total: 0 });
          setIsPollingImportDeduccionIMSS(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const menuImportarDeduccionIMSS = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantillaDeduccionIMSS(),
        },
        {
          key: 2,
          label: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargarDeduccionIMSS(),
        },
      ]}
    />
  );

  const generarDispersionExcel = (allRecords) => {
    // Obtener información del detalle de nómina
    const fechaCalculo = encabezado?.fecha_de_calculo
      ? moment(encabezado.fecha_de_calculo).format('DD/MM/YYYY')
      : '';

    // Tipo de Nómina Empleado
    const tipoNominaEmpleado = tiposNominasEmpleados?.find((e) => e.id === encabezado?.tipo_de_nomina_empleado);
    const tipoNominaEmpleadoDesc = tipoNominaEmpleado?.descripcion || '';

    // Periodicidad de Pago
    const periodicidad = periodicidades?.find((e) => e.id === tipoNominaEmpleado?.periodicidad_de_pago);
    const periodicidadDesc = periodicidad?.descripcion || '';

    // Tipo de Nómina
    const tipoNomina = tiposNominas?.find((e) => e.id === encabezado?.tipo_de_nomina);
    const tipoNominaDesc = tipoNomina?.descripcion || '';

    // Periodo Fiscal
    const periodoFiscal = periodosFiscales?.find((e) => e.id === encabezado?.periodo_fiscal);
    const periodoFiscalDesc = periodoFiscal?.periodo || '';

    // Periodo de Nómina Detalle
    let periodoDetalleDesc = '';
    let fechaInicioPeriodo = '';
    let fechaFinPeriodo = '';
    if (encabezado?.periodo_de_nomina_detalle && periodosNominasDetalles) {
      const periodoInfo = periodosNominasDetalles.find((pd) => pd.id === encabezado.periodo_de_nomina_detalle);
      if (periodoInfo) {
        periodoDetalleDesc = periodoInfo.numero_de_nomina || '';
        fechaInicioPeriodo = periodoInfo.fecha_inicial ? moment(periodoInfo.fecha_inicial).format('DD/MM/YYYY') : '';
        fechaFinPeriodo = periodoInfo.fecha_final ? moment(periodoInfo.fecha_final).format('DD/MM/YYYY') : '';
      }
    }

    // Fecha de pago (fecha final del periodo)
    const fechaPago = encabezado?.fecha_final_nomina
      ? moment(encabezado.fecha_final_nomina).format('DD/MM/YYYY')
      : '';

    const sujetoUpper = sujetoLabels.singular.toUpperCase();
    const colNumero = `NUMERO ${sujetoUpper}`;
    const colApellidoPaterno = `APELLIDO PATERNO DEL ${sujetoUpper}`;
    const colApellidoMaterno = `APELLIDO MATERNO DEL ${sujetoUpper}`;
    const colNombre = `NOMBRE DEL ${sujetoUpper}`;
    const colNombreCompleto = `NOMBRE COMPLETO DEL ${sujetoUpper}`;

    const excelData = allRecords.map((record) => {
      const netoAPagar = parseFloat(record.importe_neto_dispersion_bancaria) || 0;
      const nombreCompleto = `${record.nombre || ''} ${record.apellido_paterno || ''} ${record.apellido_materno || ''}`.trim();

      return {
        [colNumero]: record.numero_de_empleado || '',
        [colApellidoPaterno]: record.apellido_paterno || '',
        [colApellidoMaterno]: record.apellido_materno || '',
        [colNombre]: record.nombre || '',
        [colNombreCompleto]: nombreCompleto,
        CUENTA: record.cuenta_bancaria || '',
        IMPORTE: netoAPagar,
      };
    });

    const excelRows = [];

    // Título
    excelRows.push(['SISTEMA DE NÓMINA']);
    excelRows.push(['REPORTE DE DISPERSIÓN BANCARIA']);
    excelRows.push([`Compañía: ${razonSocial}`]);
    excelRows.push([]);

    // Información del detalle de nómina
    excelRows.push(['INFORMACIÓN DE LA NÓMINA']);
    excelRows.push([`Fecha de Cálculo: ${fechaCalculo}`]);
    excelRows.push([`No. de Nómina: ${encabezado?.numero_nomina || ''}`]);
    excelRows.push([`Periodo: ${periodoDetalleDesc}`]);
    excelRows.push([`Fecha de Periodo: ${fechaInicioPeriodo} al ${fechaFinPeriodo}`]);
    excelRows.push([`Fecha de Pago: ${fechaPago}`]);
    excelRows.push([]);

    // Encabezados de columnas
    excelRows.push([
      colNumero,
      colApellidoPaterno,
      colApellidoMaterno,
      colNombre,
      colNombreCompleto,
      'CUENTA',
      'IMPORTE',
    ]);

    // Datos
    excelData.forEach((row) => {
      excelRows.push([
        row[colNumero],
        row[colApellidoPaterno],
        row[colApellidoMaterno],
        row[colNombre],
        row[colNombreCompleto],
        row.CUENTA,
        row.IMPORTE,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(excelRows);
    worksheet['!cols'] = [
      { wch: 20 }, // NUMERO
      { wch: 30 }, // APELLIDO PATERNO
      { wch: 30 }, // APELLIDO MATERNO
      { wch: 30 }, // NOMBRE
      { wch: 40 }, // NOMBRE COMPLETO
      { wch: 25 }, // CUENTA
      { wch: 15 }, // IMPORTE
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DispersionBancaria');
    const fechaActual = moment().format('YYYY-MM-DD_HH-mm');
    const fileName = `Dispersion_Bancaria_${encabezado?.numero_nomina || selected}_${fechaActual}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const onClickDispersion = () => {
    setShowDispersionModal(true);
  };

  const onClickDetener = async () => {
    setLoadingDetener(true);
    const result = await postDetenerCalculo(encabezado?.id);
    if (result !== false) {
      onSetCalculando(false);
      notification.info({
        message: 'Cálculo Detenido',
        description: 'Se detuvo el cálculo. Los empleados ya procesados quedan guardados. Puede recalcular para completar.',
        placement: 'topRight',
        duration: 8,
      });
      // Mismo criterio que al terminar un cálculo completo (onCalculoTerminado): regresa al
      // primer tab para que el usuario revise el resultado parcial desde un punto conocido.
      onCalculoDetenido?.();
    }
    setLoadingDetener(false);
  };

  const onConfirmRecalcular = async () => {
    try {
      setLoading(true);
      const res = await recalcularNomina(encabezado.id);
      if (res) {
        setVisibleRecalcular(false);
        onEncabezadoUpdate({ ...encabezado, fecha_final_calculos: null, nomina_calculada: false });
        onSetCalculando(true);
        notification.info({
          message: 'Recálculo iniciado',
          description: res.mensaje || 'El recálculo de la nómina ha sido iniciado.',
          placement: 'topRight',
          duration: 6,
        });
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmRecalcularEmpleados = async () => {
    try {
      setLoading(true);
      const res = await recalcularNominaEmpleados(encabezado.id);
      if (res) {
        setVisibleRecalcularEmpleados(false);
        onEncabezadoUpdate({ ...encabezado, fecha_final_calculos: null, nomina_calculada: false });
        onSetCalculando(true);
        notification.info({
          message: 'Recálculo por empleado iniciado',
          description: res.mensaje || 'El recálculo de los empleados seleccionados ha sido iniciado.',
          placement: 'topRight',
          duration: 6,
        });
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleDispersionConfirm = async (dispersionType) => {
    setShowDispersionModal(false);
    if (!selected || !data?.results?.length) {
      message.warning('No hay datos disponibles para realizar la dispersión.');
      return;
    }
    try {
      setLoading(true);
      message.loading({ content: 'Preparando datos de dispersión...', key: 'dispersion' });

      if (dispersionType === 'excel') {
        const rawData = await getDispersionBancariaNomina(selected);
        const allRecords = formatReceivedClone(rawData);
        if (allRecords.length === 0) {
          message.error({ content: 'No se encontraron registros detallados.', key: 'dispersion' });
          setLoading(false);
          return;
        }
        generarDispersionExcel(allRecords);
        message.success({ content: 'Excel de dispersión generado con éxito', key: 'dispersion' });
        setLoading(false);
        return;
      }

      // Formato PAG — generado por el backend (layout Banorte)
      const resultado = await descargarPagDispersionBancaria(selected);
      if (resultado) {
        const element = document.createElement('a');
        element.href = URL.createObjectURL(resultado.blob);
        element.download = resultado.filename;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        URL.revokeObjectURL(element.href);
        message.success({ content: 'Dispersión PAG generada con éxito', key: 'dispersion' });
      } else {
        message.error({ content: 'Error al generar el archivo de dispersión.', key: 'dispersion' });
      }
    } catch (error) {
      // No se refleja el mensaje crudo del servicio externo al usuario
      // (puede filtrar detalles internos de esa API); se registra solo
      // para diagnóstico y se muestra un mensaje genérico.
      // eslint-disable-next-line no-console
      console.error('Error al procesar la dispersión bancaria:', error);
      message.error({ content: 'Error al procesar la dispersión bancaria', key: 'dispersion' });
    } finally {
      setLoading(false);
    }
  };

  const screens = Grid.useBreakpoint();
  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };
  const rules = {
    required: [requiredRule],
  };

  const [empleadoSeleccionado] = selectedRowKeys;
  const registroSeleccionado = (data?.results || [])
    .find((row) => row.id === empleadoSeleccionado);
  const periodoDetalleInfo = periodosNominasDetalles?.find(
    (pd) => pd.id === encabezado?.periodo_de_nomina_detalle,
  );
  const periodoDetalleTexto = periodoDetalleInfo
    ? `${periodoDetalleInfo.numero_de_nomina || ''} (${
      periodoDetalleInfo.fecha_inicial ? moment(periodoDetalleInfo.fecha_inicial).format('DD/MM/YYYY') : ''
    } al ${
      periodoDetalleInfo.fecha_final ? moment(periodoDetalleInfo.fecha_final).format('DD/MM/YYYY') : ''
    })`
    : '';
  const contextoAsistenteIA = {
    nominaId: encabezado?.id,
    numeroNomina: encabezado?.numero_nomina,
    tipoNominaEmpleadoDescripcion: encabezado?.tipo_de_nomina_empleado_descripcion,
    periodoDetalleTexto,
    empleadoNumero: registroSeleccionado?.empleado_numero,
    empleadoNumeroYNombre: registroSeleccionado?.empleado_numero_y_nombre_completo,
  };

  return (
    <Row className="container">
      <AsistenteChatWidget contexto={contextoAsistenteIA} />
      <Spin tip="Calculando..." spinning={calculando}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            storageId={TABLE_STORAGE_ID}
            cols={columns}
            data={data?.results || []}
            rowSelection={rowSelection}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            handleOnRowClick={handleOnRowClick}
            baseURI={baseURI}
            controls={{
              onClickEdit: () => onClickDetalle(),
            }}
            customActions={[
              {
                onClick: onClickExportarExcel,
                text: 'Exportar Excel',
                icon: <FileExcelOutlined />,
                disabledBySelection: false,
                disabled: !data?.results?.length || !selected,
              },
              // Agregar Plaza solo aplica a Nómina ordinaria: las nóminas extraordinarias
              // (Aguinaldo, Liquidación, Anticipo de Aguinaldo, etc.) determinan sus plazas
              // por otros mecanismos (layout, cálculo por empleado), no por alta manual.
              ...(encabezado?.tipo_de_nomina === NOMINA_ORDINARIA ? [{
                onClick: () => onClickAdd(),
                text: 'Agregar Plaza',
                icon: <PlusCircleOutlined />,
                disabledBySelection: false,
                disabled: encabezado?.estados_globales === ESTATUS_AUTORIZADO || encabezado?.estados_globales === ESTATUS_CANCELADO,
              }] : []),
              {
                onClick: () => onClickDelete(),
                text: 'Eliminar Plaza',
                icon: <MinusCircleOutlined />,
                disabledBySelection: encabezado?.estados_globales !== ESTATUS_AUTORIZADO && encabezado?.estados_globales !== ESTATUS_CANCELADO,
                disabled: encabezado?.estados_globales === ESTATUS_AUTORIZADO || encabezado?.estados_globales === ESTATUS_CANCELADO,
              },
              // La Dispersión Bancaria requiere el permiso dedicado
              // `nominas.dispersion_nomina`, distinto del permiso general de
              // esta pantalla (ver/editar nominaplaza).
              ...(hasActionPermission('nomina', 'dispersion') ? [{
                onClick: onClickDispersion,
                text: 'Dispersión Bancaria',
                icon: <BankOutlined />,
                disabledBySelection: false,
                disabled: encabezado?.estados_globales === ESTATUS_CANCELADO,
              }] : []),
            ]}
            // Requiere el permiso dedicado `nominas.importar_nomina`, distinto
            // del permiso general de esta pantalla (ver/editar nominaplaza). Solo aplica a
            // Nómina ordinaria (ver comentario en Agregar Plaza).
            allowCustomImport={!!selected && hasActionPermission('nomina', 'importar') && encabezado?.tipo_de_nomina === NOMINA_ORDINARIA}
            customImportMenu={menuImportarDeduccionIMSS}
            customImportText="Importar DED-02, DED-01 y P101"
            editText="Ver Recibo"
            permission={permission}
            allowExportPDF={false}
          />
          <div style={{
            display: 'flex', alignItems: 'center', position: 'absolute', bottom: 0, right: 0,
          }}
          >
            <CheckCircleTwoTone
              twoToneColor="#d88f4f"
              style={{
                fontSize: '23px',
                marginRight: '5px',
              }}
            />
            <Text style={{ fontSize: '0.8rem', color: '#d88f4f' }}>
              {encabezado?.tiempo_de_calculos}
            </Text>
          </div>
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <Row justify="space-between">
                <Text>Detalle Recibo</Text>
                <Row className="form-submit-controls">
                  <Button
                    type="link"
                    onClick={onClickVerRecibo}
                    disabled={loading || loadingPdfModal}
                    loading={loadingPdfModal}
                    style={{ marginRight: 8 }}
                  >
                    <EyeOutlined />
                    {screens.md && 'Ver Recibo'}
                  </Button>
                  <Button
                    type="link"
                    onClick={async () => {
                      await onClickPreview();
                    }}
                    disabled={loading}
                    loading={loadingPdf}
                  >
                    <FilePdfOutlined />
                    {screens.md && 'Imprimir Recibo'}
                  </Button>
                  <Button
                    type="link"
                    onClick={onCancel}
                    disabled={loading}
                  >
                    <ArrowLeftOutlined />
                    {screens.md && 'Regresar'}
                  </Button>
                </Row>
              </Row>
            )}
            onCancel={onCancel}
            forceRender
            width="85%"
          >
            <Form
              layout="vertical"
              form={form}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="fecha" label="Fecha" hasFeedback>
                    <DatePicker allowClear format="DD/MM/YYYY" value={encabezado?.fecha_de_calculo ? moment(encabezado.fecha_de_calculo) : null} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="periodo_nomina" label="Periodo de Nómina" hasFeedback>
                    <Input allowClear disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="empleado" label={sujetoLabels.singular} hasFeedback>
                    <Input allowClear value={nombreEmpleado} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="puesto" label="Puesto" hasFeedback>
                    <Input allowClear value={puesto} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="plaza" label="Plaza" hasFeedback>
                    <Input allowClear value={plaza} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="area" label="Área" hasFeedback>
                    <Input allowClear value={area} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="rfc" label="RFC" hasFeedback>
                    <Input allowClear value={rfc} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="curp" label="CURP" hasFeedback>
                    <Input allowClear value={curp} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="nss" label="NSS" hasFeedback>
                    <Input allowClear value={nss} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="fecha_alta" label="Fecha de Alta" hasFeedback>
                    <Input allowClear value={fechaDeAltaEmpleado} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="sueldo_diario" label="Sueldo Diario" hasFeedback>
                    <Input allowClear value={sueldoDiario} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="banco_pago" label="Banco de Pago" hasFeedback>
                    <Input allowClear value={bancoPago} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="numero_cuenta" label="Número de Cuenta Bancaria" hasFeedback>
                    <Input allowClear value={numeroCuenta} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="cuenta_contable_retencion_pago" label="Cuenta Contable para Retención de Pago" hasFeedback>
                    <Input allowClear disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="sindicato" label="Sindicato" hasFeedback>
                    <Input allowClear value={sindicato} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item name="tipo_de_empleado_presupuestal" label="Tipo de Empleado Presupuestal" hasFeedback>
                    <Input allowClear disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Tabs
                activeKey={currentTabKey}
                onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                type="card"
              >
                <TabPane tab="Nómina" key="nomina" forceRender>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                      <NominasPercepciones data={nominasPlazasPercepciones} />
                    </Col>
                    <Col xs={24} lg={12}>
                      <NominasDeducciones data={nominasPlazasDeducciones} />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                    <Col xs={24} lg={12}>
                      <div style={{ maxWidth: '1100px' }}>
                        <NominasDescuentos data={nominasPlazasDescuentos} />
                      </div>
                    </Col>
                    <Col xs={24} lg={12}>
                      <div style={{
                        display: 'flex', flexWrap: 'wrap', gap: 16, paddingTop: 0,
                      }}
                      >
                        <div style={{
                          display: 'flex', flexDirection: 'column', gap: 16, flex: '1 1 260px',
                        }}
                        >
                          <CurrencyInput name="importe_percepciones" label="Importe Percepciones" value={nominaPlaza?.importe_percepciones} hasFeedback disabled style={{ width: '100%', textAlign: 'right' }} />
                          <CurrencyInput name="importe_deducciones" label="Importe Deducciones" value={nominaPlaza?.importe_deducciones} hasFeedback disabled style={{ width: '100%', textAlign: 'right' }} />
                          <CurrencyInput name="importe_descuentos" label="Importe Descuentos" value={nominaPlaza?.importe_descuentos} hasFeedback disabled style={{ width: '100%', textAlign: 'right' }} />
                          <CurrencyInput
                            name="importe_neto"
                            label="Importe Neto"
                            value={nominaPlaza?.importe_neto}
                            hasFeedback
                            disabled
                            style={{
                              width: '100%', textAlign: 'right', fontWeight: 'bold',
                            }}
                          />
                        </div>
                        <div style={{
                          display: 'flex', flexDirection: 'column', gap: 16, flex: '1 1 260px',
                        }}
                        >
                          <CurrencyInput
                            name="importe_neto_monedero"
                            label="Importe Monedero"
                            value={nominaPlaza?.importe_neto_monedero}
                            hasFeedback
                            disabled
                            style={{ width: '100%', textAlign: 'right' }}
                          />
                          <CurrencyInput
                            name="importe_neto_dispersion_bancaria"
                            label="Importe Transferencia Electrónica"
                            value={nominaPlaza?.importe_neto_dispersion_bancaria}
                            hasFeedback
                            disabled
                            style={{
                              width: '100%', textAlign: 'right', fontWeight: 'bold',
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="ISR" key="isr" forceRender>
                  <NominasISR data={nominasPlazasPercepciones} encabezado={nominaPlaza} />
                </TabPane>
                <TabPane tab="IMSS" key="imss" forceRender>
                  <NominasIMSS data={imssNominas} encabezado={nominaPlaza} />
                </TabPane>
                <TabPane tab="ISN" key="isn" forceRender>
                  <NominasISN data={nominasPlazasPercepciones} encabezado={nominaPlaza} />
                </TabPane>
                <TabPane tab="IPEJAL" key="ipejal" forceRender>
                  <NominasIPEJAL idParent={selectedRowKeys} encabezado={nominaPlaza} />
                </TabPane>
                <TabPane tab="Otros Pagos" key="otros_pagos" forceRender>
                  <NominasPlazasOtrosPagos data={nominasPlazasOtrosPagos} />
                </TabPane>
              </Tabs>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            open={showPdfModal}
            onCancel={onClosePdfModal}
            footer={null}
            width="90%"
            style={{ top: 20 }}
            bodyStyle={{
              padding: 0, height: '80vh', display: 'flex', flexDirection: 'column',
            }}
          >
            <Spin spinning={loadingPdfModal} tip="Cargando recibo...">
              <div style={{ backgroundColor: '#fff', padding: '20px 24px', borderBottom: '1px solid #f0f0f0' }}>
                <Row justify="space-between" align="middle">
                  <Text strong style={{ fontSize: '18px' }}>
                    Recibo de Nómina -
                    {nombreEmpleado}
                  </Text>
                </Row>
                <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
                  Período:
                  {' '}
                  {encabezado?.numero_nomina ? `${moment(encabezado.fecha_inicial_nomina).format('DD/MM/YYYY')} AL ${moment(encabezado.fecha_final_nomina).format('DD/MM/YYYY')}` : 'No disponible'}
                </Text>
              </div>
              <div style={{
                flex: 1, padding: '20px', backgroundColor: '#f5f5f5', overflow: 'auto',
              }}
              >
                {pdfBase64 ? (
                  <iframe
                    src={pdfBase64}
                    style={{
                      width: '100%', height: '100%', border: '1px solid #d9d9d9', borderRadius: '4px', backgroundColor: 'white',
                    }}
                    title="Vista previa del recibo"
                  />
                ) : (
                  <div style={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#999',
                  }}
                  >
                    <Empty description="No hay recibo para mostrar" />
                  </div>
                )}
              </div>
              <div style={{
                padding: '16px 24px', borderTop: '1px solid #f0f0f0', backgroundColor: '#fff', display: 'flex', justifyContent: 'flex-end', gap: '8px',
              }}
              >
                <Button
                  onClick={() => {
                    if (pdfBase64) {
                      const downloadLink = document.createElement('a');
                      const nombreLimpio = nombreEmpleado ? nombreEmpleado.replace(/[:*?"<>|]/g, '') : sujetoLabels.singular;
                      const fileName = `Recibo_Nomina_${nominaPlaza?.id}_${nombreLimpio}.pdf`;
                      downloadLink.href = pdfBase64;
                      downloadLink.download = fileName;
                      downloadLink.click();
                    }
                  }}
                  disabled={!pdfBase64}
                  icon={<DownloadOutlined />}
                >
                  Descargar
                </Button>
                <Button type="primary" onClick={onClosePdfModal}>Cerrar</Button>
              </div>
            </Spin>
          </Modal>
          <ModalDelete
            onDelete={onClickEliminarPlaza}
            onCancel={() => setVisibleEliminar(false)}
            open={visibleEliminar}
            content={`Plaza ${plazas?.find((e) => e.id === form.getFieldValue('plaza'))?.clave}`}
            loading={loading}
          />
          <Modal
            open={visibleAgregar}
            title={(
              <FormSubmitControls
                label="Agregar Plaza"
                onCancel={() => setVisibleAgregar(false)}
                onFinish={agregarNominaPlaza}
              />
            )}
            footer={null}
            closable={false}
            width="40%"
          >
            <Form layout="vertical" form={formPlaza} scrollToFirstError name="general">
              <Col xs={24} sm={24} md={24}>
                <Form.Item name="plaza_id" label="No. de Plaza" rules={rules.required} hasFeedback>
                  <Select
                    key="id"
                    labelProp="clave"
                    dataSource={filtrarPlazasPorSujeto(adminPlazas)}
                    onChange={(value) => {
                      const plazaSeleccionada = adminPlazas.find((x) => x.id === value);
                      setNombre(getNombreSujeto(plazaSeleccionada));
                    }}
                    render={(value) => `${value?.clave || 'Sin clave'} - ${value?.puesto || 'Sin puesto'}`}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item label={`No. de ${sujetoLabels.singular}`} hasFeedback>
                  <Input disabled value={nombre} />
                </Form.Item>
              </Col>
            </Form>
          </Modal>
          {/* MODAL : IMPORTAR DED-02, DED-01 Y P101 */}
          <Modal
            open={visibleModalImportarDeduccionIMSS}
            title={(
              <FormSubmitControls
                label="Importar DED-02, DED-01 y P101"
                onFinish={onUploadDeduccionIMSS}
                onCancel={() => {
                  setVisibleModalImportarDeduccionIMSS(false);
                  formCargaDeduccionIMSS.resetFields();
                }}
                loading={loading}
              />
            )}
            onCancel={() => {
              setVisibleModalImportarDeduccionIMSS(false);
              formCargaDeduccionIMSS.resetFields();
            }}
            footer={null}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            forceRender
            destroyOnClose
          >
            <Spin tip="Cargando..." spinning={loading}>
              <Form
                layout="vertical"
                form={formCargaDeduccionIMSS}
                name="cargaDeduccionIMSS"
                onFinish={onUploadDeduccionIMSS}
              >
                <Dragger
                  label="Archivo"
                  limitMB={30}
                  rules={[{ required: true, message: 'El archivo es requerido' }]}
                  name="file"
                  allowedExtensions={['xlsx']}
                />
              </Form>
            </Spin>
          </Modal>
          {/* MODAL : PROGRESO IMPORTACIÓN DEDUCCION IMSS */}
          <Modal
            open={isPollingImportDeduccionIMSS}
            title="Importando DED-02, DED-01 y P101..."
            footer={null}
            closable={false}
            maskClosable={false}
            centered
          >
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <Progress
                type="circle"
                percent={
                  progresoImportDeduccionIMSS.total > 0
                    ? Math.round((progresoImportDeduccionIMSS.en_curso / progresoImportDeduccionIMSS.total) * 100)
                    : 0
                }
              />
              <p style={{ marginTop: 16 }}>
                {progresoImportDeduccionIMSS.en_curso}
                {' / '}
                {progresoImportDeduccionIMSS.total}
                {' registros procesados'}
              </p>
            </div>
          </Modal>
          <ModalExportOptions
            visible={showExportModal}
            onCancel={() => setShowExportModal(false)}
            onConfirm={handleExportConfirm}
          />
          <ExportadorExcelPersonalizado
            visible={showExportadorPersonalizado}
            onCancel={() => setShowExportadorPersonalizado(false)}
            data={fullData}
            fileName={`Nomina_${encabezado?.numero_nomina || selected}_Personalizado_${moment().format('YYYY-MM-DD')}`}
            sheetName="NominaPersonalizado"
            titulosPorColumna={TITULOS_COLUMNAS_NOMINA}
          />
          <ModalDispersionOptions
            visible={showDispersionModal}
            onCancel={() => setShowDispersionModal(false)}
            onConfirm={handleDispersionConfirm}
            sujetoSingular={sujetoLabels.singular}
          />
          <Modal
            open={calculando}
            title="Calculando Nómina..."
            footer={(
              <Button
                danger
                onClick={onClickDetener}
                loading={loadingDetener}
              >
                Detener
              </Button>
            )}
            closable={false}
            maskClosable={false}
            centered
          >
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <Progress
                type="circle"
                percent={
                  progresoCalculo.total > 0
                    ? Math.min(Math.round((progresoCalculo.calculadas / progresoCalculo.total) * 100), 99)
                    : 0
                }
                status="active"
              />
              <p style={{ marginTop: 16 }}>
                {progresoCalculo.calculadas}
                {' / '}
                {progresoCalculo.total || '?'}
                {' Plazas Calculadas'}
              </p>
            </div>
          </Modal>
          <ModalConfirmation
            onFinish={onConfirmRecalcular}
            Confirm
            onCancel={() => setVisibleRecalcular(false)}
            open={visibleRecalcular}
            contentTitle={`Recalcular Todos — Nómina ${encabezado?.numero_nomina}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmRecalcularEmpleados}
            Confirm
            onCancel={() => setVisibleRecalcularEmpleados(false)}
            open={visibleRecalcularEmpleados}
            contentTitle={`Recalcular ${sujetoLabels.plural} Seleccionado(s) — Nómina ${encabezado?.numero_nomina}`}
            loading={loading}
          />
        </Spin>
      </Spin>
    </Row>
  );
};

export default CalculoDeNomina;
